import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/tech-academy-apac/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const FeatureCard = makeShortcode("FeatureCard");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <FeatureCard title="Configuration to allow an Integration Flow developed with ACE Toolkit to connect to Event Streams" color="dark" mdxType="FeatureCard">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "34.375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAAsTAAALEwEAmpwYAAABtklEQVQY0wGrAVT+AIKPl5mvuqa+yHp/g4l3bIiEgEw/N4mEf5ydl7i2r66nn5qPhp6blZygn6qsqbS5uI+DfJaVlYShmHqPhQCIlp1weoOSoKhyYlhoSj1YSEBBREmOi4enrbGOrsuZrsGWhHlnT0CVj4eakomAb2GNiIWnqKqIpJmBmI8Aj5+llJyYnZmEgHBhdF5UWE5Jdn+Jf5m2fJu7eZi4cJa5m6m3gnVxj4V9f316RzQsenRyoKWqgJyRgJiOAJmfmpyVe4t4YYVyZXNgVoWBgml8mlh2m1l5n2aBpGOCpmh8lm1veFRVWHd0c3FdU29mY5eTk4SbjIOakQB7fn9ZTDxTPB1URjZNSklxeIlbb5FshqR5kKp8lK5ZeJ9thaNqa3cuLS9qWVFfT0doXVh2amOLiIGMko0Af399TU5QFRcbJSUnQUdOdXl/ho+erb3K4ejs4Ontr7rFk52rWFpgKCkuOz5DLjE2EhkiGyQyd3V2e3l4AJiXlZWVlURITjc5P3x8fX9+fmJgYKWkosjIxsfHxbW1sWZnaDs9QU5NTiwxOUFES0A/QRwqPXN3fZKRjm/pyfCcAW2EAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "banner",
          "title": "banner",
          "src": "/tech-academy-apac/static/3948b83498f1661133eea14b5829d512/3cbba/eslab-banner.png",
          "srcSet": ["/tech-academy-apac/static/3948b83498f1661133eea14b5829d512/7fc1e/eslab-banner.png 288w", "/tech-academy-apac/static/3948b83498f1661133eea14b5829d512/a5df1/eslab-banner.png 576w", "/tech-academy-apac/static/3948b83498f1661133eea14b5829d512/3cbba/eslab-banner.png 1152w", "/tech-academy-apac/static/3948b83498f1661133eea14b5829d512/0b124/eslab-banner.png 1728w", "/tech-academy-apac/static/3948b83498f1661133eea14b5829d512/59ab2/eslab-banner.png 1800w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </FeatureCard>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Lab Overview</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Prerequisites</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Lab Environment</AnchorLink>
  <AnchorLink mdxType="AnchorLink">0 - Preparation</AnchorLink>
  <AnchorLink mdxType="AnchorLink">1 - Create a Topic in Event Streams</AnchorLink>
  <AnchorLink mdxType="AnchorLink">2 - Create SCRAM credentials to connect to Event Streams</AnchorLink>
  <AnchorLink mdxType="AnchorLink">3 - Create Resources in the ACE Toolkit</AnchorLink>
  <AnchorLink mdxType="AnchorLink">4 - Create Configurations in ACE Dashboard</AnchorLink>
  <AnchorLink mdxType="AnchorLink">5 - Deploy BAR file using ACE Dashboard</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Summary</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <h2>{`Lab Overview`}</h2>
    <p>{`The most interesting and impactful new applications in an enterprise are those that provide interactive experiences by reacting to existing systems carrying out a business function. In this tutorial, we take a look at an example. `}</p>
    <p>{`This session explains what configuration is needed to deploy an Integration Flow developed with ACE Toolkit that uses the Kafka Nodes to connect to an Event Streams cluster using the latest version of the ACE Integration Server Certified Container (ACEcc) as part of the IBM Cloud Pak for Integration.`}</p>
    <p>{`Lab’s takeways:`}</p>
    <ul>
      <li parentName="ul">{`Creating and Configuring an EventStreams Topic`}</li>
      <li parentName="ul">{`Configure App Connect Enterprise message flow using App Connect Enterprise toolkit`}</li>
      <li parentName="ul">{`Configuring App Connect Enterprise service`}</li>
      <li parentName="ul">{`Deploying App Connect BAR file on App Connect Enterprise Server`}</li>
      <li parentName="ul">{`Testing App Connect Enterprise API sending a message to EventStreams`}</li>
    </ul>
    <hr></hr>
    <h2>{`Prerequisites`}</h2>
    <ul>
      <li parentName="ul">{`You need to have an OpenShift environment with CP4I. For this session, your proctor will provide you a pre-installed environment, with admin access (more details below). If you want to create your personal environment, you can request an environment on IBM TechZone.`}</li>
      <li parentName="ul">{`You should have an Event Stream runtime pre-created in your CP4I on ROKS environment.`}</li>
      <li parentName="ul">{`You need to have the IBM App Connect Enterprise Toolkit installed in your desktop. Follow the sections Download IBM App Connect Enterprise for Developers and Install IBM App Connect Enterprise from `}<a href="https://www.ibm.com/docs/en/app-connect/11.0.0?topic=started-get-hands-experience" target="_blank">{`this tutorial`}</a>{` to install it.`}</li>
    </ul>
    <hr></hr>
    <h2>{`Lab Environment`}</h2>
    <p>{`For this session you will use a ROKS 4.10 environment with Cloud Pak for Integration 2022.2. For this section, your lab proctors pre-installed this cluster for you with a pre-configured IBM Event Streams instance.`}</p>
    <hr></hr>
    <h2>{`0 - Preparation`}</h2>
    <p>{`In this section you will do some initial steps to prepare your environment for the lab.`}</p>
    <p>{`Next steps, assume that you already accepted the Account invitation in IBM Cloud (account: 2543884 - itztsglenablement05). This is the same account of GitOps lab. If you didn’t accept, please check `}<a href="https://ibm-integration.github.io/tech-academy-apac/gitops/#0-preparation" target="_blank">{`the GitOps lab preparation section`}</a>{` to complete it. `}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Log in `}<a href="https://cloud.ibm.com/" target="_blank">{`IBM Cloud`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In IBM Cloud dashboard, change your IBM Cloud account to `}<strong parentName="p">{`2543884 - itztsglenablement05`}</strong>{`.`}</p>
      </li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "70.83333333333333%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABYlAAAWJQFJUiTwAAACrUlEQVQ4y41TS08TURTurzCBxJqyAeoLIaGJCsQFVPoQoWpUjBpXGqJgYgJoiCtdGxJXJiYm+gM0/gD3rFxAZFGkUCjttJ33687M/Tj3FmuIQZ3ky5k595zvnPOdO7FcLscKhQITNp1OH8L4+DjL5/Msk8mwbDYrYwSGh4bYYCrFLqRSwWhvd5Ts6WFjY6NsZmaGxWzbRrlcRrFYRLVahWEY0HW9DU3T2hDfjUYDVAydHR1IJLpwvPMYTg7m8e27CUtXEPN9n2uaym3b5EHg8TAMyP4Jxhidhdx1XT5VKPDeZJL3Dwzw+Ik4z00UuGEHXNc1HnNdB8ufdvFwcROP57bx8UMTtm3ANC2I7h3HgWVZ0lJx2eXkxBUku7vRd+Y0EvE4rk1N0plLU+iQhLMvN3Ex/QNjwxt4NV9DaauIjY2fqFQqUFUV6+vrWFtdRaPZxO7WFq5fGsH5U0mM9J1Ff1cCt7MZ7FX2pCwxz7OxsFTG6EgRN4Z38HZJQ3lnkwjWpLaiu1KpJMkt6lglDZ/PPsGDWzfx6P49TE9excLTORkrCRlz8OLZHi6f28Z0Xx3v5m001RoF7MgFiFFFoGmaktymb4X8Sr0Blfw1RaH3ujwnfWkpzMX75ToW71bw+k4dX97oRKgQWRMW6ShIxPabNK5IMkhDpVaT+npEoJK/LgkNWZxG9lrXgSo6dkt42uoh0HYJARi9O14oyUQBkfcrxnbpzKEOAwoW7GHI8D9PxNHefhCEB16OKAKN7CEmqltOAMvl1AEH50cjoqyAJjBthpoWomlGUC1OlsNw+G9C1YpQ1SKYTkSJkUw8CjrdUZdk8vyArE9NUJGo1SXzDwgNIqKf4K/dCYgki66Z0Ozww+H4HJrhtghFZen+B2FIYTSAXFLbF3KZ+3klwtcVB/vqC8e7dElkoAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "gitops 0 3",
        "title": "gitops 0 3",
        "src": "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/3cbba/gitops-0-3.png",
        "srcSet": ["/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/7fc1e/gitops-0-3.png 288w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/a5df1/gitops-0-3.png 576w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/3cbba/gitops-0-3.png 1152w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/0b124/gitops-0-3.png 1728w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/4ea69/gitops-0-3.png 2304w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/b8a32/gitops-0-3.png 2522w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">
        <p parentName="li">{`Now, click `}<a href="/tech-academy-apac/environments/" target="_blank">{`here`}</a>{` to open the `}<strong parentName="p">{`Team Environments`}</strong>{` page.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click to go to the `}<strong parentName="p">{`End-to-End Labs - Team Environments`}</strong>{`.`}</p>
      </li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "31.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAABYlAAAWJQFJUiTwAAABGUlEQVQY033Qy06DQBQG4OmmC+hbFDaEUN+Vde2qT6G0LnSnNqm66CUUaBUpcpEB6qL0d2aoBF14ki9ncnL4MwMZjS4xHA4xHo9hmiYkSQIhRHRZloVer4dutyvmnU7nXySKP5GmKXj5vg9d19Hv92EYBgZnF4MBNE2DwuaqqkJVlBo//0GStA7M81wIw1DYtwR8FkWI4hjhR1RLkma3jaBVp9MJZVniwPiui81igZ1tw1uv4SyXcFcr5EmMAwsrdh4KtlcKxbmXIDyE43U8HkHZLSn74OVminvrCrPpBDN2frCu8Tix8HR3i/3zHJlj17tZBkpp41dgVVXi2ZRm2G+34pbcu+fizXFEf93YiIMA+eGrCfn5Xdw3ietvb/TG2DoAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "team cluster1",
        "title": "team cluster1",
        "src": "/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/3cbba/team-cluster1.png",
        "srcSet": ["/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/7fc1e/team-cluster1.png 288w", "/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/a5df1/team-cluster1.png 576w", "/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/3cbba/team-cluster1.png 1152w", "/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/0b124/team-cluster1.png 1728w", "/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/4ea69/team-cluster1.png 2304w", "/tech-academy-apac/static/46f1003dd219752a53707d38150b40e3/02e61/team-cluster1.png 2604w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Open your Team’s section (A) (check the number of your team with the Lab’s proctors). Then, open your team’s `}<strong parentName="li">{`Cluster page`}</strong>{` (B).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "62.15277777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABaElEQVQoz42T2W7CMBBF8/+I7QnEC//At6C2eaChZCMkTRyyUEBwO9eVVRdC20hH43g8N7M4zmQywWw2w3w+x3Q6xWg0wmAwQL/f13Y4HGproH88Ht/R6/WwWCzgvOcKbdPAfg6HA6qqQl3XaNtWW77v93ucz2dcLpcfXK9XHUefczqdQI7How4qyxK+72O9XsPzPIRhiO12iziOEUfR99oiz3MdRxw7M2ZTSTZ2ENcMKIpCowxKabhnqqF1mK6hZamqQOi+IPVeoeIIKgqFyCLU+4VUUYtgI+2qbwX5fAl+oMoyBM9P2Hghok2CIvChdglUYpHuoDZv+mwlgtVDQZYsjQ9WK2SSTclAinWRbPVZI0TLFtwLsofMQhrccMIsqQNmZsSMIPt5LyhODoNOO+AWXqHaen+coTh5VTjZPwXFb85wOKRTMGHJ8rXfBO1BUChNU2QypE7BIAj+V7L4afljLJdLuK6LTwUYgX1A3TjPAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "team cluster2",
        "title": "team cluster2",
        "src": "/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/3cbba/team-cluster2.png",
        "srcSet": ["/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/7fc1e/team-cluster2.png 288w", "/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/a5df1/team-cluster2.png 576w", "/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/3cbba/team-cluster2.png 1152w", "/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/0b124/team-cluster2.png 1728w", "/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/4ea69/team-cluster2.png 2304w", "/tech-academy-apac/static/aad85d48832915e8e4c8c90823a1f264/d3591/team-cluster2.png 3078w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`On your cluster’s page, click `}<strong parentName="li">{`OpenShift web console`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "66.66666666666666%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACN0lEQVQ4y3WTy27TQBSG84qIZQlCCFoFK0qySB6CDYuIDQsknoAtqwooEkrKbVUESRoualI7deLb2HOLf86ZxBYV9EhHnrFnvvOfixveIw/dbg+e56HdbmMwGKDf72PQ3z17va5732614N2+Be9uE807R2g2Wzg4OML9e4fodDp4+OAQw+EQjWx5icD3Ea5DBEGA9XpN6zVikaAoCnKJsiyx3W6hhUA0X+D5iws8eRbg8VMfJ8c+lDQoNJCkAo3JdI7fP39guVzugSGSJIE2BlJKhGEIQSDDe6VdwCy8gowjJCsfq8XCnbP0fbPZoOH7AeaXl0izDEWewydgJnKwWWuxoCBSKrfPZYGIglWmtEFKZ0tSzxbHMRqsZkkLBuakJMkKKGVciqxKmRKW1tYaaAJoWzo17hvtLbH4LHsURWhwOgV5xkBSmCQxKSrqQ0pJd5mN95LqyjWtMuCsqu9OIYMqZ2Capq4WrJxrw++UUjUwdwBdB+TGVUAWdw0o9krTLKV0lEs1JsUiF25tSFGUGqqxJoitlQKlW3OwGsjK2I2k6NLgJtMEsnanjlNmsCgsNYye4i9gQjBNsNH3T3j54RVOzsd4Mxvh7Wzs/HjyHl/96U5PrWxnu8bgX4WShngyO8PpdISPBHn9bYTT8y94dzbCePYZv9YXe8BOXVXHyq8BqxoKmvY8ETemzA0yWtd/D4OrEvwXyEoFd5aaUmgaE/JtuXe6xH/OarVyk8Bzx6PCE8Hd5vt/ADBYyb7nDYQqAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "openshift console",
        "title": "openshift console",
        "src": "/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/3cbba/openshift-console.png",
        "srcSet": ["/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/7fc1e/openshift-console.png 288w", "/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/a5df1/openshift-console.png 576w", "/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/3cbba/openshift-console.png 1152w", "/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/b485f/openshift-console.png 1302w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Great, now let’s check your Cloud Pak for Integration environment. First we need to get the Platform Navigator URL and password. Let’s do it! Back to the OpenShift Web Console, open `}<strong parentName="li">{`Workloads`}</strong>{` (A) and `}<strong parentName="li">{`Secrets`}</strong>{` (B) again.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.59722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABz0lEQVQoz42R3U7bQBCF9yWKVMlAKdSEFCeBJG6diuBYjVDVAG4QiLuqUh+yD9GLXvaqUiV+pKoFBxzH3l3vYXaD8yNQxUgj767PfjNnli1aFuqVCtZKG7BtG77vw3VdNJtNeJ6HVqs1l/qs3W4jCAJ0Oh1a76LbfY+wt4e9bgC2W9tCUG/AsTfQPzmFEAJxHENKiacGJ+n3X0OcXQmwdwRzKzWUVl8hPDrG7c2NAeZ5buA6lVJmr7/jUHPAYSrx7cc1fp4nYPZmFY3WDhasF+jtHyJKqMORAOeZgUWDCEmSGODgNsYok8gEFZOC9hGdq7kCzN+u44P7Bm75NfbDPlKhIPNpdX2x6PLsKjP5LxYEleAim3Qs6JKkoswpO2iQ5aWlFfQOP5FQYcRzpDQYLSqAOQEvrzOcU15GGWl0p5nR6o71f12Ulchyyanh2XMLvYMQo3ugFkmywwUn+5zAEr//prgg4J8BJ40gN6lxxMV4vga4Wd3GW5qhtfwSHwk4Gfq9oBiPnlU0pLkl4xRy9oHUFLiuLbse1tbLOAiPxhJVCKbrx2KqU5M9q2w1UHaqWCDLYf/4gfB/OdtZAWXeTgd+0IW2/vnL1zngU2O2wztpyNl0UXqCWgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore7 1",
        "title": "explore7 1",
        "src": "/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/3cbba/explore7_1.png",
        "srcSet": ["/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/7fc1e/explore7_1.png 288w", "/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/a5df1/explore7_1.png 576w", "/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/3cbba/explore7_1.png 1152w", "/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/26482/explore7_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`Now filter by `}<strong parentName="li">{`cp4i`}</strong>{` project (A) and open the `}<strong parentName="li">{`ibm-iam-bindinfo-platform-auth-idp-credentials`}</strong>{` secret (B).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.45833333333333%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACUklEQVQoz2WS207bQBCG8xBVxakQKEnIyXaCE9KmEUKoVa/7Ztz3ATgICBf0DVoJqZe9aWlUIUhScrQTx45jJ193LYxCsTQaaXb38//PTGRtdRU1tkkunycaXSevKBSULFoywaf9PXYKOqqqomlakIvFIqVSiXK5HGQZu7u7VCoVdF0nkkwrKDmdWCLJ4uo6nw8OaHy/4ufXb/Tu6ty3uzQaDVqtFu12O8gyms0m9Xr92VkkrWjEkxk2YlssCeDp2SngY9hTTGeK68N47PD/5zgOpmkyGo2e1CNqvhAoXN9MsCyAJ8dH4Dm0+jb9octk4jEcDESeMJ1O8X0fzxO14ZBer0e/38d13cd6JJlRSKSyRF/HWVyJcnJyDLMJneEEU6j0pmA5Np54MJvNAqiMEGgYRgCSZwEwtpVGL74JoC8Wljk+PBQEk9Z9D7M3YGQMsO5u8YXCmbAkYfKxtDwQyqVl/+FnMkfU7SL77z+yLaAb8RRnR4fYtV9c/6jR/H1Dt/YHs3b9CApV2rYdAC3LelQYAHPFMnv7HyiUymQ1nS+Xl3hmn9u7Lr2OidE1sYYW/hxQhgTKoUjrT4CxRIqMmhdDifNy6RXV6rk0xl/DxXJnTEQPbWEvtBVGaPmZQtnDtJITa5MIhlKtVgVvIiY8xh6Li0JZ2KdwINOHWqhwfgMiiVSGUrlCKquxsLJG9fwM3BEdc4wjltAVY5ZKQhVhDyWo2+0GayOBwZQlMJlRg/7tvH3H2kaci4sqM9/jpjViaHvikgDO9Wm+h51O58naSIX/AARaAxeCRjEiAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore7 2",
        "title": "explore7 2",
        "src": "/tech-academy-apac/static/4180e2a3ad8ab3076dda18807f7d30ba/3cbba/explore7_2.png",
        "srcSet": ["/tech-academy-apac/static/4180e2a3ad8ab3076dda18807f7d30ba/7fc1e/explore7_2.png 288w", "/tech-academy-apac/static/4180e2a3ad8ab3076dda18807f7d30ba/a5df1/explore7_2.png 576w", "/tech-academy-apac/static/4180e2a3ad8ab3076dda18807f7d30ba/3cbba/explore7_2.png 1152w", "/tech-academy-apac/static/4180e2a3ad8ab3076dda18807f7d30ba/026b8/explore7_2.png 1288w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Scroll down and click to copy the `}<strong parentName="li">{`admin_password`}</strong>{`. You are welcome to take note of this password.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB40lEQVQoz6VSW08aQRTeP9DaVsECQmprtBWQi5eKIDQaXnxrH3xrLaLWmAiECIRe/6R9apv2obZNqLAXl9nZC1/PjvrkkpB0ki979sycb77vnJFmtraQ2t7G7IvnCBaLGFtbw+1MBrdWV8XXt76OyUJBwJ/Pi/ydbBbjFN+jvbu5nIiv/6VHwRCWozFMhyPIrTzFu5MTVA4P0azV0CI0qtUrVChXRZPidr2OD80m3jcaeEvnP7Za+NRui5wUSy9jLpaALxDGwdEx/ndJ8eQi4sk0fPdDePW6DEuX0fl+ir8/PhNO0fv1Ddr5HzBdA+cclmV5wrZtsS8lSGEml0cw/AA7pT1YnEHu/IahdcHUcxgXMqEHQ1dgW1yoGAwGN+Aux3EgZQubeLZRRHQhhUqtDr3P0VP1oZaui70IXaXSfDwpyPyBKVJYhqb3oagqyTfdKs/CYZcIy7FEGi7puD+IlzslMNrQDRvMdDyteeKKmHPD7eGS6GEo8pCGskuNsGGZ5tBeeSm2DQOMO+ibNqQn9GRSSyuITM9gd+9ANFZRFDG1UeAQqdHpQPv6BerZ2eWU5+bjZDmA8v4bcWu324VJKkeFRTVMlonw56XCx9EFTEyGUCrvCwuMsZEVCrjvkJz1aSj/ANenAxmnf66LAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore7 3",
        "title": "explore7 3",
        "src": "/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/3cbba/explore7_3.png",
        "srcSet": ["/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/7fc1e/explore7_3.png 288w", "/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/a5df1/explore7_3.png 576w", "/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/3cbba/explore7_3.png 1152w", "/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/26482/explore7_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`Now, let’s get the Platform Navigator URL. Open `}<strong parentName="li">{`Networking`}</strong>{` (A) and `}<strong parentName="li">{`Routes`}</strong>{` (B).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABy0lEQVQoz6VRTU8aURSdP1Bt1QoFtSQMaNU6gihfjnbDwqbduHGjVVAJjYkYIxBMP35k22XTrkjTVqd8DDPz5uP0vldJF8CCeJOTd+fed8+c864kv9xBfG8P0d1dBHI5jGcyGEun8SCVEudjVYVve1tgemtL1B9ms5ikfIJ6jzY3Rd77luTgDFYiUTylU02mcH11hfNSCdWLC9QIlXL5DudUK6NKef3yEu+rVbyrVMT9D7UaPtbroiY9U+KYX1Yw6Q/i9O0Z7hvSMhEq8XVM+QLIHxfhmS38+vYJv79/IXyG1viK9s0PGHoblmXBtu2BcBxH9CVldQ2q+gLhyIIghGtD+9mA2b6F0bqB2flD0GDqTTi2JVR4ntcHHq7rQtpJJPBqIwlZjhLhKUzm4LbZGWqpNzyIkCuVckT4mjYXCoWx/+YIHd1As9Ui+YxPDRwc9pN/lpUYNhJJ+AOzODjMw6SGbjowmDvQ2jDwYJxwaSWGyMISfER4mD+G69AjMzb0rfqICI7rkQAPumFCek5LkecXiXAOR4UTYZVb5lsbBRazoXe7/xVOP5kRhLbNoGkaGKkcFV1OGKP34/AH51A4KQqrhmGMrJBvmBP+BR95A7816F7AAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore8 1",
        "title": "explore8 1",
        "src": "/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/3cbba/explore8_1.png",
        "srcSet": ["/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/7fc1e/explore8_1.png 288w", "/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/a5df1/explore8_1.png 576w", "/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/3cbba/explore8_1.png 1152w", "/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/26482/explore8_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">{`Scroll down and click on the `}<strong parentName="li">{`cp4i-navigator-pn`}</strong>{` location to open the Platform Navigator.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "61.45833333333333%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACe0lEQVQoz1VT227TQBD1X0BvaXpJ2zRt4qSpkrZErXhCQnwigld6UUvhAcRX8NAXBK1IE9tx7MR2Ysde7/owu25ArDUae/fo7Jk5Y221UECttIl6o4FisYh6vYHmQQO1apXedei6Trmusq7XcNRu4fj4CCcnJ2i3WvTdxtnZKTqdDprNJrSdShX7+gFK27tYWF7F23fv0TUd/HzowrBsmAMLvX4Ptm2jZ9j43bNUHtgWHo0u+uaQwsZwOFQYrVKto7xXw3ppBwsrRVxd30AuxjMI5CvLMpUHvsC9zWB5HDNG+/SITOZ/S9ve3VcK1za38XypgA/nF+pgGsXgXCBNGWZxDME57HEMN0gwiRjCWUykMRK6dZakYCknPIe2Vd7DXq2hFD5bXMH5xaUiDEmCIGVccMRJrFRaAUdvlGIcZZiwDL7vw7PHiNMMKV0uhMgJpUJFSArnhIylikSCZGQURs/BwHARuB5mroPw7juY5+UlP2E1qU72UJa8VFjDxeWV6p03TVQfUy7LiyCSBOavPu67Y5iWj6kzhGsZGEbAeMKo5CeFtcYhZEjCRTJFEsqVprnCuSEZY3j80SVnPXLURzB0kQW+UjfHKcLdfT0fm50KllfXcXl1DTKQGs0UUZImmIZTZYrZdyhcuIMxpiMH/mSUu50JRcjoUq3VeYlXr9/g6MUpGodtfPn6TREJMuP/gQBMGhebjKFuIObz3ewvTlalSWX1ZgulckW5fPPxVikcBTFiJigShFGoynH8BANPjk4+Nl4YYDqTGK7OFWG1fgD5t2xslbFS3MDtp8/qtijOx0YC5ehIF81xgofBDMYoITJpREqmZQo37+EfMjoDNtXWOdwAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore8 2",
        "title": "explore8 2",
        "src": "/tech-academy-apac/static/10714e35dce5a20bfcb8f7a7ab69fa63/3cbba/explore8_2.png",
        "srcSet": ["/tech-academy-apac/static/10714e35dce5a20bfcb8f7a7ab69fa63/7fc1e/explore8_2.png 288w", "/tech-academy-apac/static/10714e35dce5a20bfcb8f7a7ab69fa63/a5df1/explore8_2.png 576w", "/tech-academy-apac/static/10714e35dce5a20bfcb8f7a7ab69fa63/3cbba/explore8_2.png 1152w", "/tech-academy-apac/static/10714e35dce5a20bfcb8f7a7ab69fa63/026b8/explore8_2.png 1288w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 12
    }}>
      <li parentName="ol">{`If necessary, accept all the risks, and click `}<strong parentName="li">{`IBM provided credentials (admin only)`}</strong>{` link.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABtElEQVQoz5WTvU7rQBCFeQgSO04c8Hp3ba+jXIc4QEAC8S+4Eop0JQqukCiQoCQtJRUtFBTUPAC0PAZvwJMcZjaySYIQUIx219Z8O2fm7IzjOKhWq+B1Ovh7rVZDFEWI49iuxb44j++TJMHM74AFJPl8Af37MVBzolZlcigDaK0JYOxZKWnDGDMJ5HU6bIWUnLYyW5km8N/tI3SyDoTwLSjv9um8SBfqD2ABZYDneTZGQNdK3Ty5RdpZR7Pp4O7qBQ83r9g9+I8g9HF0OMRg/xxCzo2ApTyvhkAEUFSFpJsrlUoJXNn6h4SqFGGA89NLPD++4eoeUNkm/iQxUtOmFsQfwFlKbtQbJM9AyRhifh5114XLPSQ4y837GzDtLhbyLvZ3DjE4e4LKDxC2UtvncigVqs53HSwRJA8VciHREyHavk9AD1I00VsbYO/4GlFs0FvcQjdbRsSDWFlDfjG0KkrgLAHTRh2aJFuZLN+hnhZTVgqtdgdZvmqHwhbhihliqLqF/vKkD4sqGVzlfhYx5kOe4Eg6+S+eNLSW8nfGZs999Tq+fSl2P+bL6adXAMoY+8fGfgfM+1ovaWdUDQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore8 3",
        "title": "explore8 3",
        "src": "/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/3cbba/explore8_3.png",
        "srcSet": ["/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/7fc1e/explore8_3.png 288w", "/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/a5df1/explore8_3.png 576w", "/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/3cbba/explore8_3.png 1152w", "/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/26482/explore8_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 13
    }}>
      <li parentName="ol">{`Log in with `}<strong parentName="li">{`admin`}</strong>{` user and the password that you copied in the previous step.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB+klEQVQoz5VTu27UQBR1SYlQbI8fY69f4xl7tdi7TpQNKEDCQwkoWoSUggiJAimUSbtlaGihoKDmA6DlM/gDvuRwZ9a7bEJSUByN74zvmXPvPWO5rgvHcaDXq9D7nuehLEtIKc26/F7G699KKVjXEd1MuCRR/15AZ4ZQJ23Y9go2xU4PuycUOlEUq+QsTyCEIILKxEWRG1RVBUsnZIMYIssMAsbgM9eszHXAtEJKroeNUSaI+PnjY7RNizTlhqibTCneogsFLMlDtLTZ0I9j2lARR+4xFL4HFfhgRKxL3XvzCXX7AFHk4vP8J75+/IWnhydIMo7jo3PMDk6R5jGsWquTFcIoBo8XCDmnOIIMQ3g94c7+KyhSmWYJTt+e4ce335h/AYpmD3eVRF2NqAUSluI+xMBGOvCRJCkpiAxiIpZhsOghVaDL7aaPUI0mGHcTHDw5wuzddxTdIbJhbfpshqIShfD+HHz4AlHggoecECIiVIbQR55G2Nyd4dnrC5RUzebWPibNNko9iJ1ddO/PTRWGMB+QBR5+QDF6iZII8iBA1vewJDCjsMBw1KLp7pmhaItoxZqkInXj6fZfHzrOBtidW2D2bRqA33twYXR7zYd6govSyX/ysqFFnl82tuN6BLbyn3PF2NpzN72Oa1/K/zy9JcEKa2fa2H8AUk1eGhwkGc4AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore8 4",
        "title": "explore8 4",
        "src": "/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/3cbba/explore8_4.png",
        "srcSet": ["/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/7fc1e/explore8_4.png 288w", "/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/a5df1/explore8_4.png 576w", "/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/3cbba/explore8_4.png 1152w", "/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/26482/explore8_4.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 14
    }}>
      <li parentName="ol">{`Close the `}<strong parentName="li">{`Welcome`}</strong>{` dialog. Great, now you are ready for the lab. Enjoy it!`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB+klEQVQoz3VTyW4TQRAdYrxgW8KxZ+mZnh57PKuXKMIKPmCyiEUKCLhx5JJDjrlEHJH4ASQO/O+jqpx25gCHp+qaqXpV9arbUUqBEUURgiCA7/ti/wfP55gA6sHneIbWBuk8h6O1RhzHYMuwAb7vwvfchk8ggpiLkx17nnxTQUjEPsbjY+Q5EdoOLTgoCikpzhCZDDpSsEU9KlCaGOf5HOt5ilmxwXb7GYtyQxOGRFjA4UAGtx+GIabTKRIT4vL9V9zc/EFdVCjKElmW4fztJ6xOX2BZFDgrcpi0xurlNZKkJg6NqqoeR+bumJDPs9kMu90OVxfXWNRrCazrCq+/3OFksyO/RDJLZVStKTdQlJdguVjDaQprz0qRVialApEk7aXwMNYruL6m0T36Fop+jCikCT2FulruO+TOmtuVrT1snbfPMaPRCJ12C71eD47jYDgcypj8n8FFCpLCsdt97E7tkzsddLtdsUzSbj8VIovhYCDSGGMOOyhJ64OGTcJ+vy9JrVYLA0o8OnqCbu8Zvt3e4/7HL3z/+Rsnp2cijTGJdMi5QsgOj9y81FYCHoN913XFbl9d4uLNB1y9+4h5Vhyuk30UsuV/EfLV4UvK1mrEo/FiPHeC49FzOfM0HM+Wi0qHzWfV7NAWshc+SRLRjMFn+whszmQyEcK/ePQ+hD1IeZ8AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore9 1",
        "title": "explore9 1",
        "src": "/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/3cbba/explore9_1.png",
        "srcSet": ["/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/7fc1e/explore9_1.png 288w", "/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/a5df1/explore9_1.png 576w", "/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/3cbba/explore9_1.png 1152w", "/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/26482/explore9_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`1 - Create a Topic in Event Streams`}</h2>
    <ol>
      <li parentName="ol">{`Navigate to the Event Streams instance from the CP4I Platform Navigator. Click on `}<strong parentName="li"><em parentName="strong">{`es-demo`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABpklEQVQoz3VSS67UMBCcAyCh4Y2T2HH+cb6eJDNk9GAFrJDYcAYklhyBE3Dporv1nCcWLEr9kVNd1Z1TmqZgZFkmsNYijuP/IEJsMsTqjOT8BlEUIVLvCGfESQKT5zhJk5BTURSFkCqlBNwPUQgTDWUHXPYfePr+G1ZHsN0XJO4zkT7J21OY3nWdkHJzHEc0TXP0GZxHcYLCJlAff6H49ge7/4Ru/orl+Se0TmG0eSVkMrabkHRWqbUWco4hV+qCNCuQZylZfksEtCJj0RY0tPYY3fZKyHZFxcsKyrJEXTdCnhojteSpkZ1XVfPSywWa1sE4hf045+QhKzGkaJqvmAlst51G+OsNXT+j76luW+yPHfu+U93T4PoQ8g+hISXB5uyvaB19XNUobwua/T3cMBBZQ+oqeO+xLIuQl2V1/AmHZZ7Eti8XBUtKh/mOlhXRIFboPjyjXYmY1LCiYfJwXU/Hq8X6QRikMhkfJSic/Ip+mOTaTHAjhdv9jlFUtljXFY/HQyLXh+VwRb4yW+Yrc+SHG4GV8zoGiiEPlu80YNs26WmdCM9fjiYSEb5Gd1MAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 1",
        "title": "ACE Toolkit integration with ES Configuration Step 1",
        "src": "/tech-academy-apac/static/d38ce3874fa1b3c84ad5bba1179edfe5/3cbba/2021-09-18_12-53-40.png",
        "srcSet": ["/tech-academy-apac/static/d38ce3874fa1b3c84ad5bba1179edfe5/7fc1e/2021-09-18_12-53-40.png 288w", "/tech-academy-apac/static/d38ce3874fa1b3c84ad5bba1179edfe5/a5df1/2021-09-18_12-53-40.png 576w", "/tech-academy-apac/static/d38ce3874fa1b3c84ad5bba1179edfe5/3cbba/2021-09-18_12-53-40.png 1152w", "/tech-academy-apac/static/d38ce3874fa1b3c84ad5bba1179edfe5/0b124/2021-09-18_12-53-40.png 1728w", "/tech-academy-apac/static/d38ce3874fa1b3c84ad5bba1179edfe5/277bd/2021-09-18_12-53-40.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`From the Event Streams Home page click on the `}<strong parentName="li"><em parentName="strong">{`Create a topic`}</em></strong>{` tile.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABtElEQVQoz21SXWsTURDdHyz4VPBfJHlpC0VMQpJ1RfAvCD6IDwqm1KKFgFrTbpq7u/fe/f46nbPpxgQdONyZOzPnzpld59nzE3jea0ynU0wmkw7j8Rjz+RyLxQKu62I2m+HdWxdnZ+c4Pb/AbO7CXezyPVjneR6ci5evQEuSBGVZoiiK7uxt+WONMDK4NcA6bFFWDRJJf1+XEPcfc4bDYeeEYQhjzB5hFCGKQtysfuP9lzW8jwlevKnw+cbicvkVl9crKBVAa9b9hTMajY4IExvDF6KfwRZZHGMbGHz4dAVrAlz/srj1DQL1gNhauTOwcsZSx5NwBoPBkeQsz7Hc3OHb1seDNfgTKaR5hrIQnY2so8i6tfRgX09K7CVzupJFTY17o1FX1e4heWQjstpmt7BK7klCMlqWZf8n1FqjyAuYNMXKv4evFO7UFhuZMkri7rFcpicRG4unOJX6Q9l7Qkql1TKJkgl1liKtK1iRy6a2bbs8iRj3f8LhhEeEvKCcuq5l0rxDK34jIAGJmKufYhKxnmcvt5Pcf2UlErkbFnCfWsBGguvoc4wP/VjWEYQBjDYdxyPCauUM5g5F2AAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 2",
        "title": "ACE Toolkit integration with ES Configuration Step 2",
        "src": "/tech-academy-apac/static/6556c14882faa69a3880a7d59bc78839/3cbba/2021-09-18_13-15-14.png",
        "srcSet": ["/tech-academy-apac/static/6556c14882faa69a3880a7d59bc78839/7fc1e/2021-09-18_13-15-14.png 288w", "/tech-academy-apac/static/6556c14882faa69a3880a7d59bc78839/a5df1/2021-09-18_13-15-14.png 576w", "/tech-academy-apac/static/6556c14882faa69a3880a7d59bc78839/3cbba/2021-09-18_13-15-14.png 1152w", "/tech-academy-apac/static/6556c14882faa69a3880a7d59bc78839/0b124/2021-09-18_13-15-14.png 1728w", "/tech-academy-apac/static/6556c14882faa69a3880a7d59bc78839/277bd/2021-09-18_13-15-14.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`The wizard will guide you during the process. In the first screen type the topic name. In my case I have used `}<strong parentName="li"><em parentName="strong">{`kafka-cp4i-demo-topic`}</em></strong>{`. You can use any name, you will use it later on when cofniguring your Flow in the Toolkit.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABNUlEQVQoz5VSy06EMBTtf/kd7l0af8UYV25MDBtgZNZ+hUtjfE0MLAYob+iDgczi2DaBzHQ0EZLTS+49nHPaQlzXheM4CIIAwXptqu/7v8LzPMO5vbnG+cUlzq7ucffgInhU89XKfEuklOjlDkseKTg+NhGeNhL5uD+akTDOEKUFaF6irBoURQVKqUGe5yjL0qBpGnRdh7ZtwTnHfhww9C1e6db0JpC3bYLn7xDvWQkuRrR8QJJSRFGIOI6NcJqmyqhAVVWo6xqMMXQKkkt8VTmyrkUvhDEiQi2fBUXS1Nip7Qu1HT3QEIqkj0Savpj700xXqer0rivRIi9Fioazo4E4IB6KCEvANjAJdWRmEWziCSzDWVAvveW6BLYR+TPBP2HOWcjZgOgbW5rKTlirC2UdM3/BD/pO6yYnso2EAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 3",
        "title": "ACE Toolkit integration with ES Configuration Step 3",
        "src": "/tech-academy-apac/static/52fa5bb84fa8dc28dccbe1f0a68344a6/3cbba/2021-09-18_13-15-50.png",
        "srcSet": ["/tech-academy-apac/static/52fa5bb84fa8dc28dccbe1f0a68344a6/7fc1e/2021-09-18_13-15-50.png 288w", "/tech-academy-apac/static/52fa5bb84fa8dc28dccbe1f0a68344a6/a5df1/2021-09-18_13-15-50.png 576w", "/tech-academy-apac/static/52fa5bb84fa8dc28dccbe1f0a68344a6/3cbba/2021-09-18_13-15-50.png 1152w", "/tech-academy-apac/static/52fa5bb84fa8dc28dccbe1f0a68344a6/0b124/2021-09-18_13-15-50.png 1728w", "/tech-academy-apac/static/52fa5bb84fa8dc28dccbe1f0a68344a6/277bd/2021-09-18_13-15-50.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`You can review the different options, but for simplicity I’m accepting the defaults, so you can simply click `}<strong parentName="li"><em parentName="strong">{`Next`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABA0lEQVQoz6WSzUrEMBSF82S+hnuX4tOIDLjRWUxa0s08zOx0YVuotDXt5NcpIh6T4Iwx1J/BwEdyc3PPPSEhlK6wXN6iKJijAGMMWZbNQikFc2cWV5c4PTvHycU1FjcrsNzl8zzUEm0stHnGG/4+XqYJm/sHrO8UXpNC0vUcfBTouAAfBIZhRNe2aB1937t4AOc84glKaeymHR5lB6MktkJAfECklDBGH7DWBLGyLFFVFeq6Dvh10zShiVIqIJ2w1r7OhNkTBEXUwcf7ZIovtNYeBOJ5D4mD3/jSwOhZUfKdm59cpq7ifZImjyVtSOY2j3Vsjf28sn+t/zoctyOUVOGLvQOTgexaX1WP4gAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 4",
        "title": "ACE Toolkit integration with ES Configuration Step 4",
        "src": "/tech-academy-apac/static/bce4522d21c54cc4b88e8662ccd742b1/3cbba/2021-09-18_13-16-47.png",
        "srcSet": ["/tech-academy-apac/static/bce4522d21c54cc4b88e8662ccd742b1/7fc1e/2021-09-18_13-16-47.png 288w", "/tech-academy-apac/static/bce4522d21c54cc4b88e8662ccd742b1/a5df1/2021-09-18_13-16-47.png 576w", "/tech-academy-apac/static/bce4522d21c54cc4b88e8662ccd742b1/3cbba/2021-09-18_13-16-47.png 1152w", "/tech-academy-apac/static/bce4522d21c54cc4b88e8662ccd742b1/0b124/2021-09-18_13-16-47.png 1728w", "/tech-academy-apac/static/bce4522d21c54cc4b88e8662ccd742b1/277bd/2021-09-18_13-16-47.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`You can change the retention period, but I’m accepting the default clicking `}<strong parentName="li"><em parentName="strong">{`Next`}</em></strong>{` without manking any change.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABEUlEQVQoz5WRz0rEMBDG82q+hldv4tMoIl50D9uW9OS7eFPwZjfZpkmaP2UR4XMSd9kSyrIb+DHDN99MpwmrqjVWq1e0LSdacM7R1DXqBaqqAifP48M9rm9ucXX3jKeXNXhD9abJvcyHCB8mXHJ+dju8f3zh7dPht6gxIRV6pbFVhqKB2Gp8dxKbjYCUEkqpTN/3MMbAWovgPdwU0I0SwY0wpNk9LJmtNQghEB6R4kBa13U0dAMhRI4JrXX2eRpoxxHWOcr/+5KWYMnkyTRNUzbHGPfD4yw/6ofGgz7PE6w0z41LlPWyj5XmpXzJM99qrrNT659D+UF26vfOIV9ZON41c/RSl25VbqiNhhsdhmHAH+mj7QclzzgBAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 5",
        "title": "ACE Toolkit integration with ES Configuration Step 5",
        "src": "/tech-academy-apac/static/2978c559c3036b7f61ba0f160f662f95/3cbba/2021-09-18_13-17-12.png",
        "srcSet": ["/tech-academy-apac/static/2978c559c3036b7f61ba0f160f662f95/7fc1e/2021-09-18_13-17-12.png 288w", "/tech-academy-apac/static/2978c559c3036b7f61ba0f160f662f95/a5df1/2021-09-18_13-17-12.png 576w", "/tech-academy-apac/static/2978c559c3036b7f61ba0f160f662f95/3cbba/2021-09-18_13-17-12.png 1152w", "/tech-academy-apac/static/2978c559c3036b7f61ba0f160f662f95/0b124/2021-09-18_13-17-12.png 1728w", "/tech-academy-apac/static/2978c559c3036b7f61ba0f160f662f95/277bd/2021-09-18_13-17-12.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`Click `}<strong parentName="li"><em parentName="strong">{`Create Topic`}</em></strong>{` to complete the wizard.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABI0lEQVQoz5WSSU7EMBBFfTOWnIQdGyS4AIdgSbcQGZwjsOAc7JCgEye2M9nOIIH42G4iQpRuNZGebP+q+lVxQoLgEdvtBklCLQkopYjCEOEKQRAgjilurq9wfnGLs8sN7u4fQGMbjyJfS7TpoE2P/zw8S/H0wvD8+oHPr78xUnAJWTXgsoawcFEhzQq8pxwsF1YrIaWEEAJlWaJpGgzDgLdWoOsqGNWitlrzA+GcI93t7KGGMdpivAFjDEWeI8+Z32dZBpfr4kopCFvcKg2t9zVudRBXXBSFT+r73nbtfMIcp036ZNC5/ew8QSbBvcY4jn6dd1yyjJmFKZlPsDbJmuHSZJ5Ljk1yCss6ckrSMfb3+XvvxH2MU6c51LyqK6hW+d/qG8eY7ETJpcJRAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 6",
        "title": "ACE Toolkit integration with ES Configuration Step 6",
        "src": "/tech-academy-apac/static/451e54fbb9ba43422a70192a7ab29a9e/3cbba/2021-09-18_13-17-40.png",
        "srcSet": ["/tech-academy-apac/static/451e54fbb9ba43422a70192a7ab29a9e/7fc1e/2021-09-18_13-17-40.png 288w", "/tech-academy-apac/static/451e54fbb9ba43422a70192a7ab29a9e/a5df1/2021-09-18_13-17-40.png 576w", "/tech-academy-apac/static/451e54fbb9ba43422a70192a7ab29a9e/3cbba/2021-09-18_13-17-40.png 1152w", "/tech-academy-apac/static/451e54fbb9ba43422a70192a7ab29a9e/0b124/2021-09-18_13-17-40.png 1728w", "/tech-academy-apac/static/451e54fbb9ba43422a70192a7ab29a9e/277bd/2021-09-18_13-17-40.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`The new topic will be displayed in the `}<strong parentName="li"><em parentName="strong">{`Topics`}</em></strong>{` page. First confirm the topic was created and then return to the home page clicking on the `}<strong parentName="li"><em parentName="strong">{`Home icon`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABFklEQVQoz6WSS07DMBCGfU7OgDgFO4iSbBGwLK/EJBGPE3AFFnRXlaSFPJxXSSHJz9hqqmRRiRRLn8aesX/Nb5sdHB3i8nqCs5sr3N5zuI4D27a3cM4Hc4nneXAJzilHecuyVN2hs0w/v0ALIKhW+Muo6waPDy4md08wnoGX6bDOTjUNZfWFxccSb8sAiRAQSYIoipCmqYoJrQXlwzBETPPA9zF/9zELBBafAqk8s4EdayfwqxKvwRzTNEbTtmh3IEcXm6ahRY2f7zXyPEdRFApmGobakFE363KFgor5SKRQF5mu60pQ2sr2ENspKP13bY+lL8r0jWUp2L+LMWJ9Bh3ua7csyt6jmOa/LEvROInpUTP1xX4BjM/lxFJz2n4AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 7",
        "title": "ACE Toolkit integration with ES Configuration Step 7",
        "src": "/tech-academy-apac/static/d9694924fcfee9de38e2484899e697b7/3cbba/2021-09-18_13-18-29.png",
        "srcSet": ["/tech-academy-apac/static/d9694924fcfee9de38e2484899e697b7/7fc1e/2021-09-18_13-18-29.png 288w", "/tech-academy-apac/static/d9694924fcfee9de38e2484899e697b7/a5df1/2021-09-18_13-18-29.png 576w", "/tech-academy-apac/static/d9694924fcfee9de38e2484899e697b7/3cbba/2021-09-18_13-18-29.png 1152w", "/tech-academy-apac/static/d9694924fcfee9de38e2484899e697b7/0b124/2021-09-18_13-18-29.png 1728w", "/tech-academy-apac/static/d9694924fcfee9de38e2484899e697b7/277bd/2021-09-18_13-18-29.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`2 - Create SCRAM credentials to connect to Event Streams`}</h2>
    <ol>
      <li parentName="ol">{`From the Event Streams Home page click on the `}<strong parentName="li"><em parentName="strong">{`Connect to the cluster`}</em></strong>{` tile.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABs0lEQVQoz2VSy27UQBD0Z4L4DQTKIfuQsPfBEcQfcOAPOKNISHABkRUcQjgkEGV3bI89Dz/WdqVrhC0ttNTqavdMdXV7okePn2C73WA2m2E+n2OxWGC5XCKO4+CbzUpigpebGOfnCzx9doY4SbBOXiBJ4uncer0Wni2iV6/fgOa9x/F4nHy0q9scxpRwA2AboGkatIJvUmDA/xYl0o2WpimKophcaw2dZ7j8cY2P3/7g7YXH83ctvvwssdvt8OnrFfZ7Fc7leR6cOFqtVoEwyzKUZXniVpRl2uL9h0upp7j47nD9u0R6uIc3BqrQ+JUe4K2TKQyMtYg4P805F8apqgp1XQfMWMkqKmcCRl9BGY37ssBe/PPdDW7zdCK0JBxHZtK2bcC8PO6x7/vQZJDYSa68g5fcNzXqvsPByn6NFXX/EHIHvEhSYo5M1cx5sJEmJNnLGnLZlRXlZeVFrYaT+qRwHDmoGAZ0XRcUMlLdlAuWA9DO4q7IoUSRElwIieX+/vrJyDSS8gmNDUhKpdMKpAHV0mmMo7qTkZVS4QPJxr9MIuZ8RmONTuwksm5FpZY6SXnnAWWA3LBSQvo1AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 8",
        "title": "ACE Toolkit integration with ES Configuration Step 8",
        "src": "/tech-academy-apac/static/6bc70f8f8644c963cce0b377513e7fa9/3cbba/2021-09-18_12-54-00.png",
        "srcSet": ["/tech-academy-apac/static/6bc70f8f8644c963cce0b377513e7fa9/7fc1e/2021-09-18_12-54-00.png 288w", "/tech-academy-apac/static/6bc70f8f8644c963cce0b377513e7fa9/a5df1/2021-09-18_12-54-00.png 576w", "/tech-academy-apac/static/6bc70f8f8644c963cce0b377513e7fa9/3cbba/2021-09-18_12-54-00.png 1152w", "/tech-academy-apac/static/6bc70f8f8644c963cce0b377513e7fa9/0b124/2021-09-18_12-54-00.png 1728w", "/tech-academy-apac/static/6bc70f8f8644c963cce0b377513e7fa9/e957c/2021-09-18_12-54-00.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`The wizard will guide you duirng the process. First, make sure you have selected `}<strong parentName="li"><em parentName="strong">{`External`}</em></strong>{`. Then, copy the bootstrap information and paste it in a safe place since we will need it later on. Finally, click on `}<strong parentName="li"><em parentName="strong">{`Generate SCRAM credentials`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAACCUlEQVQoz32Sy28SURjF+fc0cQ9sCPJoXLjQjatqGqsC5f1+JO5cSIRA5JFuGk1qjDaBUuortoSGx4AUFAaGgRl6vN/FoYkmTnIy351kfjnnO1d34+YtbG1twWazwWKxcJnNZlitVi673Q6TyYRHD7dRKBSQyWSQTqeRzWa56PyKieZcLged2XwbqVQKPp8PwWAQgUCAv6PRKOKxGLZ3HNh98gyl/QPUajVUj4/xv0dnNBr5z263G16vdyOPx8O/Pd59ijv3d/D8RR6n9TpOKlX0R0M0+wK6gx84G48gTCdQlkssmDgwxpz8DdS05/bh7r0HyOdzGE4mOGego/YFmqNLiLMZGpKIIVbXDvV6PZLJJPx+/yayFnutADzuPbwuFnEqdPC114MkSVAXC+7o4PwbXr57i+L7Q3y5aEJnMBiQSCS4GwJFIhEOD4VCfCY5nU6Uy2XuQGWQJZMsy1BVFQ2hiw/VCg6PPqLRaq2B8Xic70xzR7MWmcAulwtF5nA8HmPCYs/lBaS5zMH/lKIBNXfhcHjjkMqiMwFLpRIEgRXR7eJKnQMrCaPhAO1OBxKVIo+Ze2m9Q4qsXRsCEVDbKQEpMjlUFAXT6RSVhoI3n1S0B3O2S1ZMV8J+dY6T5p+WySG1rEUmOEkrx+Fw8EstiiL6/T7qZyN8bi3xU6TIK/yaXeF7D2hdKvgNGSps1CcZWbkAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 9",
        "title": "ACE Toolkit integration with ES Configuration Step 9",
        "src": "/tech-academy-apac/static/d5e75e80caa671d42f5b8599cd8258d7/3cbba/2021-09-18_19-29-39.png",
        "srcSet": ["/tech-academy-apac/static/d5e75e80caa671d42f5b8599cd8258d7/7fc1e/2021-09-18_19-29-39.png 288w", "/tech-academy-apac/static/d5e75e80caa671d42f5b8599cd8258d7/a5df1/2021-09-18_19-29-39.png 576w", "/tech-academy-apac/static/d5e75e80caa671d42f5b8599cd8258d7/3cbba/2021-09-18_19-29-39.png 1152w", "/tech-academy-apac/static/d5e75e80caa671d42f5b8599cd8258d7/0b124/2021-09-18_19-29-39.png 1728w", "/tech-academy-apac/static/d5e75e80caa671d42f5b8599cd8258d7/277bd/2021-09-18_19-29-39.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`In the pop up window type the name of the user you want to create. In my case I have used `}<strong parentName="li"><em parentName="strong">{`ace-es-user-scram`}</em></strong>{`. Then click `}<strong parentName="li"><em parentName="strong">{`Next`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAACVUlEQVQoz2WS30tTYRyH909FbArtR4prCU43ddNBUMG0OQhyLhdF6sambnObbjo1u+iirgZrEs0ICQId4hxEVhcrkhJNxTnNLS+ezntEKzrw8D3vuXjez+d9j+LCRSU6nVZCh0ajkVGr1Wi1WhnxXa2+hLGpCafTSXd3N3a7XZ5dXV0yZ2uHw4FCrdZg6+yktbWV9vZ22traMBqNMs3Nzejq9dTVN3D9ph2Xy0Vvby+xWIx4PE4ymWR2dvacmZkZFLW1tXR0dMjCM+njuTnmMxky6TSpVIr08wwvsq9ZWFiQKRQKZLNZhoeHiUaj/6Coqak5F5rNZqxWK29zOTZ3dni39Z33O1ucVKtUqhV+SbMqIZ5isUgwGCSRSDA9PS2nnZycRKFSqeiUKouqAiGff7PI2tcvrH/bYL9UolwuSxxROjiU1gcc/Txm/cNHIpEIfr8ft9tNX18fQ0NDf4QioRDabDbyq6vs7+2xvbnJ7u4uJ5Vj9g5/UCx9g5OylK/CxudTYSAQwOPx0N/fj8/n+18oKmek81vN51laXia3vMTSyhqPcts8XTkgkz8iXajybPETUUkoLmdqKikj6stCUVNchpBZLBYaGxvR6/UYDAauXmlAZ2hBZX9Cnesll+/M09D/imuDKYIjAbxeH+FQkOjYKLFIGIVSqTxPKKR/IzawSpuZTS3cdtwgOTFKPOJnwDuK+0EIbyAsiUI89IXpuRvGMxg5/W3EuQmhSCc4E4p3q9WCyWTiVo+TUHgMf2CEewNB7vvGCYZjJOLSHJtgIBDHNzLOb2rUAnVN+wNyAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 10",
        "title": "ACE Toolkit integration with ES Configuration Step 10",
        "src": "/tech-academy-apac/static/a7dd7761104ea334c348e01dd191e6b3/3cbba/2021-09-18_19-38-28.png",
        "srcSet": ["/tech-academy-apac/static/a7dd7761104ea334c348e01dd191e6b3/7fc1e/2021-09-18_19-38-28.png 288w", "/tech-academy-apac/static/a7dd7761104ea334c348e01dd191e6b3/a5df1/2021-09-18_19-38-28.png 576w", "/tech-academy-apac/static/a7dd7761104ea334c348e01dd191e6b3/3cbba/2021-09-18_19-38-28.png 1152w", "/tech-academy-apac/static/a7dd7761104ea334c348e01dd191e6b3/0b124/2021-09-18_19-38-28.png 1728w", "/tech-academy-apac/static/a7dd7761104ea334c348e01dd191e6b3/277bd/2021-09-18_19-38-28.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`I will grant full access to the new user, but you can control the level of acces as needed. Once you adjust the values click `}<strong parentName="li"><em parentName="strong">{`Next`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAACNklEQVQoz2WSS08aURiG+VNNg5oImKaIi5pw9cKSKgQa60JAbBsVkCkywzBcFLVpQuKfMXHTRUtjY9JNkxoX3COIT+ccqzXpJG/m+05ynvN+F8uz51ZmZhymZrDb7VI2mw2Hw/Go6elp5udfEYvFCIfDrK6uEolEZPw0j0ajWGw2O8HlZXw+H4FAQMrtdkt5PG5evJzD6XQRWokQj8fZ2NigUqlQq9Wo1+ucnJw86vj4GMvU1BRLS0v4vF4J9fv9rK+vs7m5STKZNAFxomtxtjN5CSqVSpyennJ0dEQ+n5f5U1kmJyfvgSbMa0IXFxc5Pz9nMBjQbrfpdrv0ez1ubm4YjUYMh0PG4zEXFxeoqiqdCrhwe3BwgGViYoJls2ThTEjAz87OaLVaEtjpdLi8vqLT7dHudGm1O/T6A75+a6LrOrlcjkQiIduRTqf/AR/KFXGz2eT29pa7uzvE93s4oD/qmtEQxn35/3n5XQIVRSGVSskWZbPZ/4ELCwvs7e1hGAZasYihaeyWa4QaP3jTuCLa+EW4cU3i8xfKJZ1qtcrhYV1KlC+BokwBE/0TwLk5MVknLpeL2VmnOWkX7tA7QskKr5Nl1tKf2FLq7H9UyGSyaGqBUnEfQ9ewWK3WR4cPayPA4hFxHgwG8fu8vI2tUK9oVPS8OXGV+IciGUUzQSrbWY1YUiO1q9+vjbgkgMKd0MOAAn9zj8djLm0MVSuSUz6ytVPgfdagoBnUqmUKxQo7SpVsvswfxQv5mXNdKusAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 11",
        "title": "ACE Toolkit integration with ES Configuration Step 11",
        "src": "/tech-academy-apac/static/a15ec9a4eb6194f555f931eb5d55f1ba/3cbba/2021-09-18_19-42-36.png",
        "srcSet": ["/tech-academy-apac/static/a15ec9a4eb6194f555f931eb5d55f1ba/7fc1e/2021-09-18_19-42-36.png 288w", "/tech-academy-apac/static/a15ec9a4eb6194f555f931eb5d55f1ba/a5df1/2021-09-18_19-42-36.png 576w", "/tech-academy-apac/static/a15ec9a4eb6194f555f931eb5d55f1ba/3cbba/2021-09-18_19-42-36.png 1152w", "/tech-academy-apac/static/a15ec9a4eb6194f555f931eb5d55f1ba/0b124/2021-09-18_19-42-36.png 1728w", "/tech-academy-apac/static/a15ec9a4eb6194f555f931eb5d55f1ba/277bd/2021-09-18_19-42-36.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Adjust the values as needed and click `}<strong parentName="li"><em parentName="strong">{`Next`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAACMElEQVQoz2WSWU8aURhA+VNNg5oImKaIDzVhdeHRBQKN9UFE7KKFkRGZYQYGFLRJNfHPmPjYlobEhyZt0paHsmjEktO512rbdJKT+91J5sy3OR48dDIx4bGZwO12S1wuFx6P557x8XGmp5+QTCaJxWIsLy8Tj8dl/Pc9kUjgcLncROfnCYVCRCIRid/vlwQCfh49nsI76WNxKU4qlWJtbQ3LsqjVatTrdY6Oju45PDzEMTY2xtzcHKFgUErD4TCrq6tkMhnS6bQtSJFYSfEquytFZrnM6ekpjUaDQqGAaZr/4BgdHb0V2rKgLZ2ZmeH8/Jxer0en05HnLV1ubm4YDAYMh0NarRaapslMhVxku7+/j2NkZIR5u2SRmUDIz87OaLfbkq4tan3/agv7dLo9fnS69C+veP+hiWEY5PN51tfXZTuy2ewf4V25Im42mzKby6srxPP5us/1z74dDWB4Kc9PFx+lUFVV2Z6NjQ0URflfKEre2dmhbPdKL5UolzSy5gGLby94evKNxPEXYidtMsfvqJgG1WqVg4O6RJQvhaJMIZudnZXCqSl7sl4vPp+PyUmvPWkf/oXnLKQtFtMVVrJv2FQb7BVUcjkFXStilvYoGzoOp9N5n+Hd2gix+Il4H41GCYeCPEsuUbd0LKPAVk4j9bJETtVtkcaWopNM62ReG7drIz4SQpGd4G5Akd/3QCBgL20STS+RV3fZ3C7yQilT1MvUqhWKJYtttYpSqPALO9j5UJPzGTcAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 12",
        "title": "ACE Toolkit integration with ES Configuration Step 12",
        "src": "/tech-academy-apac/static/4defa1f679f59e11557ab2ad3b848d5c/3cbba/2021-09-18_19-45-47.png",
        "srcSet": ["/tech-academy-apac/static/4defa1f679f59e11557ab2ad3b848d5c/7fc1e/2021-09-18_19-45-47.png 288w", "/tech-academy-apac/static/4defa1f679f59e11557ab2ad3b848d5c/a5df1/2021-09-18_19-45-47.png 576w", "/tech-academy-apac/static/4defa1f679f59e11557ab2ad3b848d5c/3cbba/2021-09-18_19-45-47.png 1152w", "/tech-academy-apac/static/4defa1f679f59e11557ab2ad3b848d5c/0b124/2021-09-18_19-45-47.png 1728w", "/tech-academy-apac/static/4defa1f679f59e11557ab2ad3b848d5c/277bd/2021-09-18_19-45-47.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`Select `}<strong parentName="li"><em parentName="strong">{`All transactional IDs`}</em></strong>{` or the value you prefer and then clik `}<strong parentName="li"><em parentName="strong">{`Generate credentials`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAACWklEQVQoz2WS3U/SURjH+adaQ9wEbPSyNZWUFxWvrMSgi5qo0FoZEiCCIPEquXURbSbzomk1klZXrm68ck7tbXPWUiimoa78dM7PqWud7btzzn6/fc73+zyP6tRpNY2NeqFGdDqdIq1Wi16vVyS/NTQ00NzchNPppLfXTk9Pj9h7sdvtio7uDocDlVarw9bZiclkwmKxYDabaWlpwWg0Yrxk5IzhAoZz57l8xY7L5aKvr494PE4ikSCTyZDL5Y41MTGBqr6+no6ODgV4BI2Ew0zmHjIpfsik0ySSaSYf5SlMTzM1NUWpVKJQKBAMBonFYv9IpdFoToBtbVisVt4uLPCtUuZzeZOV8ncWN7+yv1tje3+fPaGDgwPW1tYIi4eTySTZbFZxm0qlUNXV1dEpIsuoFrMFa3s7M6V53n9YZfHLR7YqFX5Wq1Sq27zbWKf8o8rOr12WlpaJRqP4/X4GBgbo7+/H6/WeAKVDCZX1XF1ZQa4/ws3RKu9tUftdEacdoRrrnw6BgUAAj8eD2+3G5/P9D7SKyI/zeYrFIrNzc7x88ZzZV2/wFzfIvN4hOV8lUaqRfLZMTABlc9LpjCIZXwHKGkpYu4grgQaD4XB0xCjpdVo0urPousdpcj3l4s0nGN0zXB3KEwoGGB72iSaOEhsLMR6NoFKr1ccOZYelJFg+IuPburpEbU3ccHaTTYRIxfx474cYvBNmOBARoDB3fRGcgxE896KHY2Oz2RSgdCcl3SpNEnB5b21t5ZrjOuHIGP7ACLeGRrntizMaGSeZEPvYA4YCCXwjcf4CJsT+azWTPO8AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 13",
        "title": "ACE Toolkit integration with ES Configuration Step 13",
        "src": "/tech-academy-apac/static/c0ba1009260286ccabe22ddd1065250f/3cbba/2021-09-18_19-47-44.png",
        "srcSet": ["/tech-academy-apac/static/c0ba1009260286ccabe22ddd1065250f/7fc1e/2021-09-18_19-47-44.png 288w", "/tech-academy-apac/static/c0ba1009260286ccabe22ddd1065250f/a5df1/2021-09-18_19-47-44.png 576w", "/tech-academy-apac/static/c0ba1009260286ccabe22ddd1065250f/3cbba/2021-09-18_19-47-44.png 1152w", "/tech-academy-apac/static/c0ba1009260286ccabe22ddd1065250f/0b124/2021-09-18_19-47-44.png 1728w", "/tech-academy-apac/static/c0ba1009260286ccabe22ddd1065250f/277bd/2021-09-18_19-47-44.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`After a moment the credentials are generated and presented to you. Make sure to copy the password and paste it into a notepad since we will use it later.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB40lEQVQoz32Sy2saURjF/fda6F7dyNQXXRRKN12lJTRtfYzvt0J3RRAUG8w0ItS1C1OVrrrIlG5CqWaScRyd5+l8F+5EuujA4T5gfpxzvht49PgJkskk4vE4otEokyAIiMViTIlEApFIBG9en2A0GqHf76PX62EwGPiiO1qHwyECgvAUnU4HhUIB5XIZpVKJrfV6Hc1GAyenKZy9+wBp/BXL5RKLxQL/+wLhcJj9LIoi8vm8r1wux+7enr3Hs5en+PjpM1arFebzORRFwXq9xmazgWmasCzLFwM2PCf/ArmyYgHPX7zC+fkQuq4zCAE1TWNnwGXOXNdlCgSDQbTbbRSLRT8yj80lZrOQpC/YGzYOnhzHgWEYTKZlw3aOIodCIbRaLeaGQLVajcErlQrbk1KpFCaTCWazGbrdLqbTKVRVxXarwjRMBtJtCw45JGCz2WSdcXe055EJnEmnMR6PcS1f4+rbFeSfMg6HA9POc/lrp+KHqsA+BnJ31WrVd0jDonMmk4F0eQn57g7fb35DVm6h73Xcalss/9zg3jT8HlmHFJk/GwIRkHdKwLTnUJIkaPsDNqqGnefMtqm7h/Lc42dDDmnKPDLBSXw41OHo4gI7b7Jb9R6GB6QJm15cAlv2w6D+AvlccedCOn32AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 14",
        "title": "ACE Toolkit integration with ES Configuration Step 14",
        "src": "/tech-academy-apac/static/e51cdf2ddfa90f9dc88da2e6ffabc2ec/3cbba/2021-09-18_19-51-31.png",
        "srcSet": ["/tech-academy-apac/static/e51cdf2ddfa90f9dc88da2e6ffabc2ec/7fc1e/2021-09-18_19-51-31.png 288w", "/tech-academy-apac/static/e51cdf2ddfa90f9dc88da2e6ffabc2ec/a5df1/2021-09-18_19-51-31.png 576w", "/tech-academy-apac/static/e51cdf2ddfa90f9dc88da2e6ffabc2ec/3cbba/2021-09-18_19-51-31.png 1152w", "/tech-academy-apac/static/e51cdf2ddfa90f9dc88da2e6ffabc2ec/0b124/2021-09-18_19-51-31.png 1728w", "/tech-academy-apac/static/e51cdf2ddfa90f9dc88da2e6ffabc2ec/277bd/2021-09-18_19-51-31.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`Scroll down to the `}<strong parentName="li">{`*Certificates`}</strong>{` section and click on `}<strong parentName="li"><em parentName="strong">{`Download certificate`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAACBElEQVQoz3WS34sSURzF/fcKeldfZPIX9Li+9BJha6Hi79+jf4CUaEOtSi/tg8hCDxGCgca2CavOLq3uODa/Z073XhmDooHD3HthPvec7xnPg4ePEI1GEQ6HEQwGmTiOQygUYopEIggEAojHnyOdTiMWiyGRSKDdbjN1Oh10u130ej0IggAPxz1Gq9VCPp9HqVRCsVhk71qthka9jmcvkjg9fYmP52Ncfr/EaDTCbDbD/x6P3+9nH2cyGeRyuaOy2Sw7SyReIXgSB98dAKYFXddh2zZkWcZ+v4eqqjBN8ygGrBMnfwNdZTI5PDl5Cv6shztFw52kEIgOwzQAx/nXodfrRbPZRKFQOEZ2Y7N9qYg8ueyN8Bafrxf4eX8PTSNAzcBClrBUZAKm5m3i3IHH5/OB53nmhoKq1SqDl8tltqZKpVIY9Pu4WYtYrVaArcGxFUyWP3C9XEFX93BMIks9ABuNBpuZ646u3cgUTNvtE6BpmNjuJHyYbsCPl/i0uAUMFVdrBecTFdOF/gfouqtUKkeHtCy6p8DhcMiKWIlrjKciLuZ7iFuVxDVxszXw5YqM4NY6zJBGdn8bCqJAd6YUyCIPBmR2GjabDXRFgqXtYBk65vNvOHsn4L3wGrOvk0PL1CFt2Y1M4VRuOclkkkWWJAmiKELa7fBLUdkFjmOzsmnfBhnJb/ovbPpvidz5AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 15",
        "title": "ACE Toolkit integration with ES Configuration Step 15",
        "src": "/tech-academy-apac/static/78ba2354c524b01869d1d9147adb0d52/3cbba/2021-09-18_19-56-55.png",
        "srcSet": ["/tech-academy-apac/static/78ba2354c524b01869d1d9147adb0d52/7fc1e/2021-09-18_19-56-55.png 288w", "/tech-academy-apac/static/78ba2354c524b01869d1d9147adb0d52/a5df1/2021-09-18_19-56-55.png 576w", "/tech-academy-apac/static/78ba2354c524b01869d1d9147adb0d52/3cbba/2021-09-18_19-56-55.png 1152w", "/tech-academy-apac/static/78ba2354c524b01869d1d9147adb0d52/0b124/2021-09-18_19-56-55.png 1728w", "/tech-academy-apac/static/78ba2354c524b01869d1d9147adb0d52/277bd/2021-09-18_19-56-55.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Navigate to the folder where you want to save the certificate and then click `}<strong parentName="li"><em parentName="strong">{`Save`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "35.06944444444445%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAyklEQVQoz5WRaw7CIBCEuf8dPIJ3aaJGKNoH9Yf+UdNIhQIdt/WR2lqNm0wIDHyzZBmXEnmeIYSApmle61N1XSPZaxzOFqeLx5EUev5QbLGOsdlK1M7BWtsBnibaAFqudG7NFc4HXEwAGW8QR2+993dgtOQQ1OX+WKLSGm0NU791NOpwJSREzCn9ntAHTtW0AzARC6RpMoL1gf39VA7dgPYOLCFYrvJuGJ+++0vhkcDLE5QuwTKacLErUFUVjDF/Q303PI85V5hFCjc7DiOrbD/pywAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 16",
        "title": "ACE Toolkit integration with ES Configuration Step 16",
        "src": "/tech-academy-apac/static/c18d005ae7a68c91ff2d4df3960f5294/3cbba/2021-09-18_13-08-38.png",
        "srcSet": ["/tech-academy-apac/static/c18d005ae7a68c91ff2d4df3960f5294/7fc1e/2021-09-18_13-08-38.png 288w", "/tech-academy-apac/static/c18d005ae7a68c91ff2d4df3960f5294/a5df1/2021-09-18_13-08-38.png 576w", "/tech-academy-apac/static/c18d005ae7a68c91ff2d4df3960f5294/3cbba/2021-09-18_13-08-38.png 1152w", "/tech-academy-apac/static/c18d005ae7a68c91ff2d4df3960f5294/4c487/2021-09-18_13-08-38.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`Once the certifcate is saved the corresponding password will be displayed. Click on the *`}<em parentName="li">{`Copy`}</em>{` icon to paste it into a notepad for future use.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAACAklEQVQoz3WSy4vTUBjF++8puG+7KbEvF7NQunAljjMV207f78fKVTvQljD2gQtRKO5mMYwotmp1FEwV7CuZ3PSmyfHeW1JBMXDITeD+OOc7n+vGzVsIh8MIBoPw+/1CkiQhEAgIhUIh+Hw+PDp8iEQigUgkgmg0imaziVarhXa7jU6ng263C1mW4ZKk22g0GshkMsjn88jlcuJdLpdRrVTw4CiGo+PHePHqNabTKUajEcbjMf73uLxer7icTCaRTqf3SqVS4t9x9Anu3DvE09MeNpTCMDawLAuqqkLTNBBCYJrmXgJYYU7+Bjo6SWVwcPc+er0zmBawWBPoZMMuU8C2/3XodrtRr9eRzWb3kZ3YjpLJE/T7feGKizCX1KBQrlVcCzBgbm3m3IbL4/GgVqsJNxxUKpUEvFAoiHOxWEI8nhBARVGgzGbA1oBmLHH+9ROU7woMosE2mbZkB6xWq2Jmjjt+diJzMG+XAymbka7reP/NwvM3Kj4qK1hUx5eZjpeXBG+vNn+Ajrtisbh3yMvi3xw4HA5F3BlzeDH5xS5TLFQW16L4saC4+Exx9XO7myGP7KwNB3GgM1MOjMfjGAwGrGED8/kcRFtioy9BqYHJ5AN6ZzKeyacYv7vctcwd8padyBzO5ZQTi8VE5NVqJRyu1yqLTsQK2WyFeNm8b0pN/AYa5G6BWrcb0AAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 17",
        "title": "ACE Toolkit integration with ES Configuration Step 17",
        "src": "/tech-academy-apac/static/53612a8ec618a2f8e1258626d811cf72/3cbba/2021-09-18_20-13-51.png",
        "srcSet": ["/tech-academy-apac/static/53612a8ec618a2f8e1258626d811cf72/7fc1e/2021-09-18_20-13-51.png 288w", "/tech-academy-apac/static/53612a8ec618a2f8e1258626d811cf72/a5df1/2021-09-18_20-13-51.png 576w", "/tech-academy-apac/static/53612a8ec618a2f8e1258626d811cf72/3cbba/2021-09-18_20-13-51.png 1152w", "/tech-academy-apac/static/53612a8ec618a2f8e1258626d811cf72/0b124/2021-09-18_20-13-51.png 1728w", "/tech-academy-apac/static/53612a8ec618a2f8e1258626d811cf72/277bd/2021-09-18_20-13-51.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">{`Scroll up and close the wizard.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABz0lEQVQoz22SSYsaURSF/XsJZK9uxDiRRSBkk1UnNOkkDuU8K2QRaARBTRqtIEJcu5BW/4D+AMWo1TXrybs3vCKdpOBQ7xbUV+fcU74nT58hkUggFoshEomwwuEwotEoKx6PIxQK4d3bKwyHQ/R6PXS7XfT7fRbNpMFggNLtF/jC4edot9vI5/MolUooFot8r9VqaNTruLpO4ubDJ6jjH1gul1gsFvjfpQs9CPmCwSC/rCgKcrmcp2w2y8/e33zEi9fX+Hz7DavVCvP5HPv9HtvtFrvdDrZtw3UcHAyD7wysCyd/A6UySh4vX73B3d1X6LrOEAJqmsYzcHnk1Of3+9FqtVAoFLzIMraUkslAVb/DsFyYQufzGZZlsRyHZoG9XFi+QCCAZrPJbghUrVYZXi6X+UxKJpOYTCaYzWbodDqYTqc4Ho84nU7iAxbObPIPYKPR4J1Jd3SWkQmcSqUwHo+xXq+xuL/HZrOBaZosR+yNcZff0T2gdFepVDyHVBbN6XSagY6Ipuk2xzQM/R8gO6QdUmT52xCIgHKnBCSHqqrCsh1oD6Zo1oHrup6rR6VQy+SQWpaRCU6S5dAOR6MRNLGzw+GncGZww1QKgUmyqF+MJnNtcgJZqwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 18",
        "title": "ACE Toolkit integration with ES Configuration Step 18",
        "src": "/tech-academy-apac/static/7a51f45236f430845cfbe9b249209f9e/3cbba/2021-09-18_20-17-49.png",
        "srcSet": ["/tech-academy-apac/static/7a51f45236f430845cfbe9b249209f9e/7fc1e/2021-09-18_20-17-49.png 288w", "/tech-academy-apac/static/7a51f45236f430845cfbe9b249209f9e/a5df1/2021-09-18_20-17-49.png 576w", "/tech-academy-apac/static/7a51f45236f430845cfbe9b249209f9e/3cbba/2021-09-18_20-17-49.png 1152w", "/tech-academy-apac/static/7a51f45236f430845cfbe9b249209f9e/0b124/2021-09-18_20-17-49.png 1728w", "/tech-academy-apac/static/7a51f45236f430845cfbe9b249209f9e/277bd/2021-09-18_20-17-49.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 12
    }}>
      <li parentName="ol">{`Before we move to ACE we will need to convert the certificate format from PKCS12 to JKS. Open a `}<strong parentName="li"><em parentName="strong">{`Terminal`}</em></strong>{` and navigate to the location where you stored the certificate in `}<em parentName="li">{`step 8`}</em>{` and run the following command changing the `}<em parentName="li">{`cert-password`}</em>{` value for the actual password you got in setp 10.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`keytool -importkeystore -srckeystore es-cert.p12 -srcstoretype PKCS12 -destkeystore es-cert.jks  -deststoretype JKS -srcstorepass <cert-password> -deststorepass <cert-password> -srcalias ca.crt -destalias ca.crt -noprompt
`}</code></pre>
    <p>{`Now we are ready to move to ACE and create the required configuration using the information we have collected.`}</p>
    <hr></hr>
    <h2>{`3 - Create Resources in the ACE Toolkit`}</h2>
    <p>{`For this lab I have created a simple project that exposes an API to POST information into a Kafka topic.
The following picture shows the corresponding flow. Go ahead and download the Project Interchange `}<a parentName="p" {...{
        "href": "https://github.ibm.com/joel-gomez/tinkering-cp4i/blob/master/ACE/PIs/JGRESAPISCRAM.zip"
      }}>{`here`}</a>{`. Then, import the project using the `}<strong parentName="p">{`File > Import > Project Interchange`}</strong>{` option.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "54.861111111111114%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABb0lEQVQoz51S127DMAz0//9dn/pQNHAsj9jy0LLkmSupDCRFkaIVcKBM0scjqeR4PCArc9R1BSkl2QZVVSHLMmQihyhKiDxHXlYQIkPOdyEgr/mPKIoCSVFLDMpg2wHjPJGVaJoGp0YiqAbmlGI0A0x5gA8BfhyhjcV73iN4umsNaw1G8ltrkTRtC6UU+ITRQaQHWDeiHxScHmB7CWsUdHuKRLLXMGQLSXFnKW+IRM65C+FG0tZ1jYSjDziKAhMp4WQmdqMn6yjm0SuNt1SSSgdPca0NjaOI6pjQGIMED4eJB6ro6edLVRvtDfwTd/H4fWv1Tng+n8HgsxBh13UIpPCW9B32B989xi0/K9xoKXVUycP+K3gXSdu1kX1ZZtrihI/PND6ZgZbS0sL6vosFOPk3Qs5LfPBxdtz2vu80Bx1bXrcN0zRRoQUzgS37XoFznlpmUp5jJJnnJ0xXzC/AAujZbFEZg++BnNN/QITc2Re6Tk5yYFQLMAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 19",
        "title": "ACE Toolkit integration with ES Configuration Step 19",
        "src": "/tech-academy-apac/static/d92286263c95a665c0facb172ab031ae/3cbba/2021-09-19_06-39-06.png",
        "srcSet": ["/tech-academy-apac/static/d92286263c95a665c0facb172ab031ae/7fc1e/2021-09-19_06-39-06.png 288w", "/tech-academy-apac/static/d92286263c95a665c0facb172ab031ae/a5df1/2021-09-19_06-39-06.png 576w", "/tech-academy-apac/static/d92286263c95a665c0facb172ab031ae/3cbba/2021-09-19_06-39-06.png 1152w", "/tech-academy-apac/static/d92286263c95a665c0facb172ab031ae/0b124/2021-09-19_06-39-06.png 1728w", "/tech-academy-apac/static/d92286263c95a665c0facb172ab031ae/e957c/2021-09-19_06-39-06.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`First we will create a `}<strong parentName="p"><em parentName="strong">{`Policy Project`}</em></strong>{` to store the Event Streams configuration.`}</p>
    <ol>
      <li parentName="ol">{`From the `}<strong parentName="li"><em parentName="strong">{`Application Development`}</em></strong>{` pane click on `}<strong parentName="li">{`*New`}</strong>{` and select `}<strong parentName="li"><em parentName="strong">{`Policy Project`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "54.861111111111114%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABfElEQVQoz41S227CMAzt/3/YXva0PW1MGxu9JCW9JGkuLQXO7EAFaALN0pGdHufYjptJKbGpSrx+feCnKFBVFUGcvJAQ9RaCcuRWQdA3KQWkEOhbhb7vb1DXEpmgxEZbrHSL5zzHKhdE1KibFpNtMGw3iM7AyTXiNGGMEYPzeK80ppHjAd57xBiSz6RSsMaA7a1t8LQRKBoFrQ0G08F2iryGUQLGWqjOJF8qDTcM6LoeA/kF2bzfA4cDPqmLjdYoGwdLhKPK3MkJDj4EdFTk5VsheIdAvDEWeVGmzhzlJMHj8YgjTjaNM8p2IuJEcpKlbpbqfI7Bnc8unVls4ZLggbpjUbYQIhoayfuL4DWuC12+DTdxhiub5z1tdEujmD+X/ousoQXwpYk26KnD9U+ethzozZbqHEfa7jiOdxEJacu87nmewS/J4xvaKAvsdrskwoVGAvsd5T0C59yMzG+ZSBJjcmK/4Cx6F5TDnWZ7+m24MwbH8cFYD0GiPNEvpfFPLWsrdKcAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 20",
        "title": "ACE Toolkit integration with ES Configuration Step 20",
        "src": "/tech-academy-apac/static/0d1bfda772b35ece054debc0eedd110b/3cbba/2021-09-19_06-53-07.png",
        "srcSet": ["/tech-academy-apac/static/0d1bfda772b35ece054debc0eedd110b/7fc1e/2021-09-19_06-53-07.png 288w", "/tech-academy-apac/static/0d1bfda772b35ece054debc0eedd110b/a5df1/2021-09-19_06-53-07.png 576w", "/tech-academy-apac/static/0d1bfda772b35ece054debc0eedd110b/3cbba/2021-09-19_06-53-07.png 1152w", "/tech-academy-apac/static/0d1bfda772b35ece054debc0eedd110b/0b124/2021-09-19_06-53-07.png 1728w", "/tech-academy-apac/static/0d1bfda772b35ece054debc0eedd110b/e957c/2021-09-19_06-53-07.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`In the pop-up window enter the name of the project, i.e. `}<strong parentName="li"><em parentName="strong">{`CP4IESDEMOSCRAM`}</em></strong>{` and click `}<strong parentName="li"><em parentName="strong">{`Finish`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "614px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "68.40277777777779%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsTAAALEwEAmpwYAAACKElEQVQ4y52Uy27TQBSG/YxsgRdgxw4JtkgsWFXiARBCQoAEApoFrVqUqhA1bVLUNAluEttxbMcz9ngmJHGcFv2ccdLKpOEiFp/m3HLOfzyODdNto8dsKKEQxzESKaGUQpIksCwrp9PpoNvtwrbtPK7zl8hlrUYQhkM/cPt9uI6DjnmGdDLFfD7HbDbLyTKyswxpOkO69LOln+ep9mI8w9yX+WnYYYA+W+CEPtwohBAxpIggYo6RSiATUl7wNREP85iSAjQJFw7HDzWBsdtqYvPEROlrG++Jt8dNbPdcBHGKAZ8SE3h0etEC7eexK38Kl41h+SMMuYRROjrEs0oNG+XPePmlhuf7VWw2TfSDEXqepMK/YwcKXU9hEEQwvHCIrV4L9w53MGRD9IYDWofl68URh/hX8npqOBEJGv4Ar80GxmSLKEZECc7/A91QxQLHXh8fOk1om3FOSb5sev3kK/nVGiMTEnfrZdw8+Ahth4WiIjom6PxOQxPaIvzN0Fzh1lkL776d/KKwiI4peulbwQC36zs48BycJwoBY9dUG7pYP7tJItcqu5wuqaFJz/pB9RMeHpVRcS2cyxFdYATG+JUQQ99MSLeqidaoK6JXnscJXN/HRm0fTxpVMBFirEiU1EP1a+MHpOLPjYqrs0j/Y2KktNWj6h7u79bxtGLh8V4bVbsPwx349FFYXPu6dVdX1x8BjxQKsp2Q4darGu68OcWNFzWUTk38BOzlCfCUZm3pAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 21",
        "title": "ACE Toolkit integration with ES Configuration Step 21",
        "src": "/tech-academy-apac/static/70bba4de5fc5f43f2026f2d5a01dfba2/c2d66/2021-09-19_06-57-19.png",
        "srcSet": ["/tech-academy-apac/static/70bba4de5fc5f43f2026f2d5a01dfba2/7fc1e/2021-09-19_06-57-19.png 288w", "/tech-academy-apac/static/70bba4de5fc5f43f2026f2d5a01dfba2/a5df1/2021-09-19_06-57-19.png 576w", "/tech-academy-apac/static/70bba4de5fc5f43f2026f2d5a01dfba2/c2d66/2021-09-19_06-57-19.png 614w"],
        "sizes": "(max-width: 614px) 100vw, 614px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`The project appears in the `}<strong parentName="li"><em parentName="strong">{`Application Development`}</em></strong>{` pane. Expand the project and click `}<strong parentName="li"><em parentName="strong">{`(New…)`}</em></strong>{`. Then select `}<strong parentName="li"><em parentName="strong">{`Policy`}</em></strong>{` from the `}<strong parentName="li"><em parentName="strong">{`New Artifact`}</em></strong>{` menu.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "383px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "167.01388888888889%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAhCAYAAADZPosTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD4klEQVRIx+1Wy2/jZBDPf8CRP4E7N8RtxR3OiMtKsICEkOAIR6QFLnvgwONCYVkg6q4WtF1toW023bZJ+kjzoonzaOw4ieMkje3Er9iJ7d+OnUfTbQVVl+OOMvL483y/b775zYwS4vgqajUW1SqLer2ORqMBjuPovQpBENDpnqBSzCCTjGF7J45UKoV4IoF4PEE+HERRBFero1iqEE4NIVxCxuMRhsMhLMsKnrZtQ9VUHNc5NNoSBu0Chnofiiwj1OwoqDVPwIsyfSRb6KHWkgJtSzo0y4M6Vc32oNuAQapaDnqaDll3IPVVFFpDdBQDoa6sotyRIHblQAWyBTq1RbZBm2wHsEYuQD975GFI9kQ92GNaG08O4XoO2jIBjh0HjKFjn2GQTafAMAUwhTxKpSIMWrdtCw48xJQ2THc8TYK38PTm7yPyDXJokpGqVcCyPhEtSi6PZquFKpEDa4w7YhWh9SV8WtwLNtquC8/zzqgvfn5Dvm1bKqS2iGK+AaZYQLfXmxNyv8Pjg8TfeHXtNyxVcvP1GciiHQDOAtcHJupsG2W6utnt4UDu4MPDx/giuYUTYtRP2I7cxmvJ1eCQgH3PhfNshAGg60HWJJQ5Frv5f/DJ7jre33mEXFs4Uz4fZbbw0qMfcZM5OBPZHNAiQP8UQkRTNfBlNoM3H97BL5n9M0DrPQHX99Zwu5DGYZOHaprBujKykB6cpmceITfU8Erkd3y89id1xCH6gogudcD9zAHeja3i8+QmlUX3XMHfYBJ4eXsZkd7kJsbQRGilcYwoW0E4k0SJ51GpcYjmc3h9PYx3/rqLHbZ8GgGV2Ey+ZY/wVvQPXIvcw+GJeAr4WWIDtxJPEN6N4vvoGn6IPcatgy18tRdFsXo8qa9pmfjC2wbeS0bw3dEBPHsE3TTmh1j+lV3HxUOK8udUDCvJPfya3sMKWwwcHNpgahos3SDSVIT5Et7eWsFWhaHdNoxpLt1FUnxDo1BTQh35rogkz+JBNomfnqxjmaJd2lhFjqbRG7EHuL65AoeAZlHLNAxGo9FZUtyFAvVFJ+a+iW9iM5lBOFfBPWrFuzyDSL0MSR9MvdwJy4pCk2h8nmU/P447cepTTm7Ht7Ec38fN2BG+TqSxwTeC6h9YQJemS1dzYRJOv98/H+EMcJZ0i/paarQgsgKyXA+Z6gnyNQVpVg40yylIVWVUhAEkSYKzwPyFgL7DQFWhDPrQBgpU0kFfhjpVf83XviLDnJJyrvUuavjLindhLy8sPjuWLqvnIrwq4L9e+aryAvAF4PMCXrUz/rNT/g/x/52FHGccTJjnVZfmqWEYeAoDqNYUJSO9jQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 22",
        "title": "ACE Toolkit integration with ES Configuration Step 22",
        "src": "/tech-academy-apac/static/f7ef14d2442b5f6c5f44c10164262b66/7076e/2021-09-19_07-04-21.png",
        "srcSet": ["/tech-academy-apac/static/f7ef14d2442b5f6c5f44c10164262b66/7fc1e/2021-09-19_07-04-21.png 288w", "/tech-academy-apac/static/f7ef14d2442b5f6c5f44c10164262b66/7076e/2021-09-19_07-04-21.png 383w"],
        "sizes": "(max-width: 383px) 100vw, 383px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`In the pop-up window enter the name of the policy, i.e. `}<strong parentName="li"><em parentName="strong">{`es-demo`}</em></strong>{` and click `}<strong parentName="li"><em parentName="strong">{`Finish`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "590px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "63.19444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACOUlEQVQ4y4VTXWsTQRTdH+Rf8OeI7/om9E0FQXzyTbSiPlSRgAURKmhDS+1n0hSTmu90v3d2d3YnO9s2bTbHO0MS06C4y+HM1z177p27xpnXg5k6yDOJVKRI0z8QQsA0TXS7Xc1qvrh/A0mi2Wi1mmg0GjqoKApMJpM5/w9FQQxgfDHCyOUoRtcwhEjAeYKYc1yPx1h8ChW0hLnQRElN9FtcXOH81MFYnMOIoggxQQ4F4jhGGARggY8wDCFl9lfkhERkGAQCMst0nJRSl8R4/f0r3m59w7u9fbza3Mab3T3UuhZ6JoMbSXhLUGt+LGGyHLW+oOxiOI5DzKHMGaXKPkq1Q6wd1fBs5wBPjyroeAJWkKPnCvT/gYE3xMBNwVioM1QZKRi+78P1PMgwwlqjiieVLVxSTX0W0AE2ByP4jJhN55pD7WrG2uFskMYcPc/Fi+YxJAmyhUMhgUcxfShFQuNgJrQgNnc4GyjbDrlaPa1CkDibritw2usHHp63a+jQhV0lAhGtBwtnbgiq4IxEdq0+bpU/YsfqQU5FFYY0PqS92+USHle2sd5pgMURLhOqYajcxcTUITQ2lDMVlFBKLcfCw4MymsRqvugypOJbto0z28KHnxU8onMvf1WRpwGGnO4g8ahs5NC0HV0DNk1tRF/l0/lyOpz6TfVaRuJd28TKj03cWa/gwUYddz+dYPWkAcN2PN2YsyLrukwvYxn6cqjfHOqMnP7btuvh/pc6VjbauPe5iffHdfwGDt7CBXFq89MAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 23",
        "title": "ACE Toolkit integration with ES Configuration Step 23",
        "src": "/tech-academy-apac/static/3d4f68166409b424468e6b342956cf60/102e5/2021-09-19_07-08-08.png",
        "srcSet": ["/tech-academy-apac/static/3d4f68166409b424468e6b342956cf60/7fc1e/2021-09-19_07-08-08.png 288w", "/tech-academy-apac/static/3d4f68166409b424468e6b342956cf60/a5df1/2021-09-19_07-08-08.png 576w", "/tech-academy-apac/static/3d4f68166409b424468e6b342956cf60/102e5/2021-09-19_07-08-08.png 590w"],
        "sizes": "(max-width: 590px) 100vw, 590px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`The `}<strong parentName="li">{`*Policy Editor`}</strong>{` opens to enter the data. Click on the `}<strong parentName="li"><em parentName="strong">{`Type`}</em></strong>{` drop down box and select `}<strong parentName="li"><em parentName="strong">{`Kafka`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "54.861111111111114%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABXklEQVQoz51S2U7DMBD0/38OEq9IvHG8liulpY3jnE5iSpo7HtYuRilCLWKlUdZeZzw7a8b5BjwUSJIIaZoiFCFEECDgAeUCMa1X2y045/AJnPZNLmg/y7IjCDrPwkSiVDsMk0ZVd5BRBpVK9F0HVe+xfi/woCQ01adpOsI4jkfo+x4sJlWlUnARRhGePc9+16Q8J1JojfEH2W8YhgGsyCSKokBHinrayJIEb0sPkixQMoMeRuy71tbPoW1bMKNK60M7JjwR4eJugavHLW6WHIs8wWanMNJlHbXUn4AhZYbMkZpYhhEu7xe4ftrgduXjo+9syxrnw/jI3MIRFnmO15dnyDSGyiXm9VP4JpT0U1VVBw9Jtu/7dihBGNrB1HVtvXH1U2iaBqxuajsd52McxxBEJklpUZZov8xu/0BozrC5B4bUTNpcYE2ew01zns/hCE3f84faGDX/AZGZlj8BJWpSc+9iIyQAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 24",
        "title": "ACE Toolkit integration with ES Configuration Step 24",
        "src": "/tech-academy-apac/static/7d5c738425aa6bd994ebec8d604cdec7/3cbba/2021-09-19_07-12-10.png",
        "srcSet": ["/tech-academy-apac/static/7d5c738425aa6bd994ebec8d604cdec7/7fc1e/2021-09-19_07-12-10.png 288w", "/tech-academy-apac/static/7d5c738425aa6bd994ebec8d604cdec7/a5df1/2021-09-19_07-12-10.png 576w", "/tech-academy-apac/static/7d5c738425aa6bd994ebec8d604cdec7/3cbba/2021-09-19_07-12-10.png 1152w", "/tech-academy-apac/static/7d5c738425aa6bd994ebec8d604cdec7/0b124/2021-09-19_07-12-10.png 1728w", "/tech-academy-apac/static/7d5c738425aa6bd994ebec8d604cdec7/e957c/2021-09-19_07-12-10.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`The default values from the `}<strong parentName="p"><em parentName="strong">{`Kafka Template`}</em></strong>{` are used to pre-populate the policy.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "42.01388888888889%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAyUlEQVQoz62QSwvCMBCE8///noeCtaAHtbUttUkfyeYxTjzpQajQhY9llzCZWfW4dejvLZyZIMuCSIII8W/EObgfWJuxH7OFmrWGNQbJCSIX9TBiYNfOYiQ+RfxTqixLNG2LlBJmChxuV3STQU9qM6KZDWIIEO83oYqiwPlygTCmWVc0egQiXVHEcVdPmrEFNkfagKqqCke61Iw+2xWn/vF2l13eKd6wB/6cxWUDyvNxJg+Brp7r8oVwl88RSdqAws6lsqvIm+3FCyt9cjmpYGO8AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 25",
        "title": "ACE Toolkit integration with ES Configuration Step 25",
        "src": "/tech-academy-apac/static/40066e50119f8dca9d0c0cbc367cb690/3cbba/2021-09-19_07-16-01.png",
        "srcSet": ["/tech-academy-apac/static/40066e50119f8dca9d0c0cbc367cb690/7fc1e/2021-09-19_07-16-01.png 288w", "/tech-academy-apac/static/40066e50119f8dca9d0c0cbc367cb690/a5df1/2021-09-19_07-16-01.png 576w", "/tech-academy-apac/static/40066e50119f8dca9d0c0cbc367cb690/3cbba/2021-09-19_07-16-01.png 1152w", "/tech-academy-apac/static/40066e50119f8dca9d0c0cbc367cb690/8b438/2021-09-19_07-16-01.png 1525w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`Update the policy using the following values:`}</li>
    </ol>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Bootstrap servers`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`<`}{`Value copied from previos section>`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Security protocol`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`SASL_SSL`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`SASL Mechanism`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`SCRAM-SHA-512`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`SSL protocol`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`TLSv1.2`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Security identity (DSN)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`any value, i.e. `}<strong parentName="td"><em parentName="strong">{`aceflowsSecId`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`SASL config`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`org.apache.kafka.common.security.scram.ScramLoginModule required;`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`SSL truststore location`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`/home/aceuser/truststores/es-cert.jks`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`SSL truststore type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`JKS`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`SSL truststore security identity`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`truststorePass`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Enable SSL certificate hostname checking`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`false`}</em></strong></td>
        </tr>
      </tbody>
    </table>
    <p>{`The policy should look similar to this:`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "41.66666666666667%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAw0lEQVQoz52R2wqDMBBE8/9fqI8qFcQ2mvvVTpNQpVio2od5yLCczOyScWSglMMaC+89lDZQSsJaC+sc3A+VmaTPNxFCQAiJEELRc1kQ4gJpPEL6wB1A9yLDMIBzjhhjMaZpgpQKQhkYY0rqKyJVXePW9xuwbVvcH3fk5Iyx4uVBd1IJWKFOUKVUMWhKOM0zeAJqrQ/3+FW56zo0TYM5QXJFSmmqLLe6ZfBswgz0+Ri57tvI7yz3x0EKcE2wLtVdPMJeL2vwbvWR6utUAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 26",
        "title": "ACE Toolkit integration with ES Configuration Step 26",
        "src": "/tech-academy-apac/static/bb76ff1cde743b35d2a29e723e39d46f/3cbba/2021-12-21_18-52-22.png",
        "srcSet": ["/tech-academy-apac/static/bb76ff1cde743b35d2a29e723e39d46f/7fc1e/2021-12-21_18-52-22.png 288w", "/tech-academy-apac/static/bb76ff1cde743b35d2a29e723e39d46f/a5df1/2021-12-21_18-52-22.png 576w", "/tech-academy-apac/static/bb76ff1cde743b35d2a29e723e39d46f/3cbba/2021-12-21_18-52-22.png 1152w", "/tech-academy-apac/static/bb76ff1cde743b35d2a29e723e39d46f/41fed/2021-12-21_18-52-22.png 1528w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">
        <p parentName="li">{`Don’t forget to `}<strong parentName="p"><em parentName="strong">{`Save`}</em></strong>{` your changes.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Go back to the `}<strong parentName="p">{`*Flow Editor`}</strong>{` to update the flow. Select the `}<strong parentName="p"><em parentName="strong">{`KafkaProducer`}</em></strong>{` node and update the properties in the `}<strong parentName="p"><em parentName="strong">{`Basic`}</em></strong>{` tab. Use the following information as a reference:`}</p>
      </li>
    </ol>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Topic name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`<`}{`Value used in the first section> i.e. `}<strong parentName="td"><em parentName="strong">{`kafka-cp4i-demo-topic`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Bootstrap servers`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`We have configured this value in the policy, but since this is a mandatory field we will enter `}<strong parentName="td"><em parentName="strong">{`dummy`}</em></strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Client ID`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`any value, i.e. `}<strong parentName="td"><em parentName="strong">{`cp4iace-esapi-scram`}</em></strong></td>
        </tr>
      </tbody>
    </table>
    <p>{`The tab should look similar to this:`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "63.888888888888886%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB90lEQVQ4y42T226jMBCGef+H6sVqb1p1o11VPaQlBJJwtAFjfIBA+HcMSZtdaaON9GnGM2Y889vxwnCPJM3AGUPTNDBGQ7US1lrCnLHQWs+2c3QdYZf12Xe4b70o8ufg69saylgoFqN+f4AdAeGvINMtxTs6rEWnFfy0xmPAMPYdVocdvvlrPKUxemOglIK3eXtFfzxCCDEHWimhGudrSFFBki8pJho552uyrGpoiha8rpFyjod0v3xLMe957aOnDt3CbWpd4px0RRdf4u45pQISRi9rJ0GwDSF4hU1TIa0rWIp5BSvnkV0Xl1OWYurT6rkzF/8zL0hzS3ZTMrzzgiRxBQv21eFVEWddoYascB2Rr9QywfU+Q1MwkuV7Ei0Fsyybb851eDn9stlxdwhwcOO48a/yf+81Fw3znM16OIy7qbPfkf+YHRDX5azN5YBbaDrUe/3YItoGSJIUWZaDFQV4keN+F8DPExjSqaYOhahvQzdeVSW88BDjZ+DjZRfiKQzxK4hwH+7wI07pCVmwWqEUmm5Y/Qc08urlA1HJgWmCPQ6IU46E3lkuaUzdo1H0AnRHuRO6AcT0T3rC25OGGxqxJZ1qQmoDblpUVgOnEcMwYBwHnMi/xUT0wwgP9OOG2qX/oYPRwy2Inopgco1Pn5xuMOdPE34DdzrhybqLQn8AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 27",
        "title": "ACE Toolkit integration with ES Configuration Step 27",
        "src": "/tech-academy-apac/static/433880b6da8c2b5ebafd2450fe3cc6e7/3cbba/2021-09-19_07-37-59.png",
        "srcSet": ["/tech-academy-apac/static/433880b6da8c2b5ebafd2450fe3cc6e7/7fc1e/2021-09-19_07-37-59.png 288w", "/tech-academy-apac/static/433880b6da8c2b5ebafd2450fe3cc6e7/a5df1/2021-09-19_07-37-59.png 576w", "/tech-academy-apac/static/433880b6da8c2b5ebafd2450fe3cc6e7/3cbba/2021-09-19_07-37-59.png 1152w", "/tech-academy-apac/static/433880b6da8c2b5ebafd2450fe3cc6e7/41fed/2021-09-19_07-37-59.png 1528w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Select the `}<strong parentName="li"><em parentName="strong">{`Policy`}</em></strong>{` tab and in the window click `}<strong parentName="li"><em parentName="strong">{`Browse`}</em></strong>{`. From the pop-up window select the policty we just created and click `}<strong parentName="li"><em parentName="strong">{`OK`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "65.27777777777779%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACH0lEQVQ4y5VT227aQBD1/z/0R/qcNqpUKVLVREpVYQgQCNjGYHxbX9Zrr28xnM4uCSFKVakrHa9nZ+b4zOzYcF0PfhAijmNwzlFLCZEnqNsWdVVCEuqmgawbNE2NulZo0LbKfoOyJeUajj2ngxartQ3GUsgsgNhM0FBivpmhCBxUlQDPM1QFx3KfwdwkeG7JzwvkOUdZVhRzgjEfmWi7DlVZIiKVV78f8WXi4nq0xtXYwf06xaNdYLRi5GcQlJxzoZMVWVEU+r2kfAVjNFtoNUpuGMW4Wfr4YSf46aS4sWJ8nnn4ZqWYuBJ+GJ9aIoSOV1WlWaZLVmRaYUhB6kCSEZOCoX/G+3XEk0xR9x35EyKqzsmveLVV6cbe90+E9EVFWNbdC80JarG+Rdn2VAE7E76RvCc3oig6K1Q9DOIMRSmRF5WGEDVu/R2CNAejD172628ghRE1mWvSLEux80JNmqYpYpZAZDluXRd31hYJY3psFKmq6BLVC4yFtYNjreHtPNptmOYYDw9TzOdzLJZL2KsnfL038en6DlvP07OqLiK7gLLzPAen3XCdLZi3R7InUD+TMNROHUDJajSkKPAshVZ3OcwK6mygsWMUs4wCGN8nU1hUajucbvdwPAIf7lmd006+S+hYQthKjNMIW04Kd/RwBMeUJzCLBB/p/r0GyviVRegOB20bBzV3w0D/YguPiDuS3xO6/8Ch79ET1B/3By8S3QcHB9D4AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 28",
        "title": "ACE Toolkit integration with ES Configuration Step 28",
        "src": "/tech-academy-apac/static/bd0144033d2542e8b7db1432b87e6610/3cbba/2021-09-19_07-48-42.png",
        "srcSet": ["/tech-academy-apac/static/bd0144033d2542e8b7db1432b87e6610/7fc1e/2021-09-19_07-48-42.png 288w", "/tech-academy-apac/static/bd0144033d2542e8b7db1432b87e6610/a5df1/2021-09-19_07-48-42.png 576w", "/tech-academy-apac/static/bd0144033d2542e8b7db1432b87e6610/3cbba/2021-09-19_07-48-42.png 1152w", "/tech-academy-apac/static/bd0144033d2542e8b7db1432b87e6610/6e2ae/2021-09-19_07-48-42.png 1529w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`The policy with be displayed in the `}<strong parentName="li">{`*Policy`}</strong>{` field. Save your project to get rid of the error message.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "21.527777777777775%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAaUlEQVQY063MSwqEMBRE0ex/Ww1uQSJquhUn4ic+FYnEXEVocKhgwZlVlcpNQZnlJFqjD2VVYa09DMg4InLT2RVUrA1WJiLz45N+ieuO2YEs2wOBafGszqGatsf7jWtCCCce+G/U9eANOwzaNuCruEzpAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 29",
        "title": "ACE Toolkit integration with ES Configuration Step 29",
        "src": "/tech-academy-apac/static/8b08ceb5775d067ae5c467bf73311866/3cbba/2021-09-19_07-52-53.png",
        "srcSet": ["/tech-academy-apac/static/8b08ceb5775d067ae5c467bf73311866/7fc1e/2021-09-19_07-52-53.png 288w", "/tech-academy-apac/static/8b08ceb5775d067ae5c467bf73311866/a5df1/2021-09-19_07-52-53.png 576w", "/tech-academy-apac/static/8b08ceb5775d067ae5c467bf73311866/3cbba/2021-09-19_07-52-53.png 1152w", "/tech-academy-apac/static/8b08ceb5775d067ae5c467bf73311866/888a7/2021-09-19_07-52-53.png 1524w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">{`Now we will create the BAR file to deploy our flow. Navigate to the `}<strong parentName="li">{`*File`}</strong>{` menu and select `}<strong parentName="li">{`*New`}</strong>{` and then `}<strong parentName="li"><em parentName="strong">{`BAR file`}</em></strong></li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "54.861111111111114%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABxElEQVQoz42SS4/TMBSF8///B2tWaFYs0LCY4TWAJi1qp4njOO+37SSieRyu3VZMJRhwdHSdOD757nEcFviIkxhexPHq7hY3D5/w5uEjPnx/xOHg0VoCLiKIOEUYhhBCWBVZgqIsrxTFMZw4LyGlhttU2HgemjxHTYv7Jw/73Q8UeQJZZVCJj34cMfQ9OqmwFTXGoae9Ekop9L2mKskwSVFWFbhs4TOGhGizosCBzN2NCxEJtPQxWabWqKg7MlGIihZaK9RNYw211rY6bdWgazss0wTGuW2vrEowP0DIPKi2hjYERFe3Et9YQZQaA5l1nURI7/dEbQwNrYPzOE4znrxTZhW1/N7d4/Wdi7dbDj/NoIlE04ZxOJFcqIzZZW4N13W1hvM8U7sJ0iwj4hb3mx1uvmzxbsfxOQzwNeYQ1PqgTzR/km0Zz8ayrEiJpus6JJRdxBmaMoemSDjFIEiKKMz63+SYvIz78fgT/TDC3e7h+z44/SIsCOhQIhR0SG1do6HDKymOivaYelF1fp7Te84wDpjoQFa6TNsmaKW0nRsty2I1n+tLMj5XLZthIjWLv+/X/9IpsgXOFQXNp2n+J8lLhL8AQIVFnvDcttkAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 30",
        "title": "ACE Toolkit integration with ES Configuration Step 30",
        "src": "/tech-academy-apac/static/947b9fd355b30d0b1cb66b085771164b/3cbba/2021-09-19_07-59-00.png",
        "srcSet": ["/tech-academy-apac/static/947b9fd355b30d0b1cb66b085771164b/7fc1e/2021-09-19_07-59-00.png 288w", "/tech-academy-apac/static/947b9fd355b30d0b1cb66b085771164b/a5df1/2021-09-19_07-59-00.png 576w", "/tech-academy-apac/static/947b9fd355b30d0b1cb66b085771164b/3cbba/2021-09-19_07-59-00.png 1152w", "/tech-academy-apac/static/947b9fd355b30d0b1cb66b085771164b/0b124/2021-09-19_07-59-00.png 1728w", "/tech-academy-apac/static/947b9fd355b30d0b1cb66b085771164b/e957c/2021-09-19_07-59-00.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 12
    }}>
      <li parentName="ol">{`In the pop-up window enter the name of the BAR file, i.e. `}<strong parentName="li"><em parentName="strong">{`jgr-cp4i-esapi-scram`}</em></strong>{` and click `}<strong parentName="li"><em parentName="strong">{`Finish`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "590px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "84.72222222222221%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAAsTAAALEwEAmpwYAAACiklEQVQ4y4VU22oTURSdn/MD/AZ99sl38UmffJKCCFpEoSjUQgs+SEXTQlpqkrZpLnWamDrpXM5t7lGSJst9xplm0mocWDkn5+y99tprZ2KE/T5M3gOLBKIwQhAGiJM4W6M4guM6MM/MDK7rZmf67jqiKERIq2HbNrrdLkzTRLPZRK/XQ5IkmEwmmM1mV9BP+XsZk+kU/eASfDSFMR6PEQQBsYfwadV7pRT0uQ6eUvAy6GcyneHMv4SXEqHneXAdB8xj8FwPcRwjTVIqoFsLs0LLwIWAlJLsIjG+D0O32Gy38f18gM5pB1xyhHGIhLxKCUm2/zd8KWBZFobDYdaZsbpXwUZtD++PT/CiUsXaQQPvGk2stzqwZAJPjuDIFO5fQXeCYnSXNDCt1Hh7eIDPnWOs10/wunqEN9UGXu3W8Xy/gRNLoTcMYS7B2dDP2xbgnMNwPJeSLAxsCz+cIQYE5jl4WP+CyuAbfvoKQjAosmIBYr4XRKTJBBEbkj58kqpySCGR+gH2Bz08a9UQKR9eliBuwKVzlhPxPMbgOXsZOiglotV2HX3HRiTVVWKRrIWMFU2WBPDSnVEEzKvwTNEvUrlmNnH/aBeBlAsFFcVazMPjbg2HZFVI90XBBcJiXxC+7DRwe2fzSlGhXhcw7QvcqmzgY/8UI+qG5cVuKBQ59OR88iRkc7KiqE5OiOSQfN7qdRArNSfkpQktICfl5YKCL3h4QW2vtGvZIBn7Uyibsiz5twxlnxmRj6SPp60qtq02SCYinwgvbAcaQvyfkDGWvQ16r98MP1C482EHd7cO8GC7i5WvbRiDc4v+87zsl36j7WvIJkx+ZYOjHE9xPPrUwv3NLu5ttPGkcozfR7Ps0wj8zO8AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 30",
        "title": "ACE Toolkit integration with ES Configuration Step 30",
        "src": "/tech-academy-apac/static/d083afc100bcd631e420ecc2c3ff4015/102e5/2021-09-19_08-02-24.png",
        "srcSet": ["/tech-academy-apac/static/d083afc100bcd631e420ecc2c3ff4015/7fc1e/2021-09-19_08-02-24.png 288w", "/tech-academy-apac/static/d083afc100bcd631e420ecc2c3ff4015/a5df1/2021-09-19_08-02-24.png 576w", "/tech-academy-apac/static/d083afc100bcd631e420ecc2c3ff4015/102e5/2021-09-19_08-02-24.png 590w"],
        "sizes": "(max-width: 590px) 100vw, 590px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 13
    }}>
      <li parentName="ol">{`The `}<strong parentName="li"><em parentName="strong">{`BAR Editor`}</em></strong>{` is open. Select `}<strong parentName="li"><em parentName="strong">{`Applications, shared libraries, services, REST APIs, and Test Projects`}</em></strong>{` to display the right type of resources and then select your application, in this case `}<strong parentName="li"><em parentName="strong">{`JGRESAPISCRAM`}</em></strong>{`. Finally click `}<strong parentName="li"><em parentName="strong">{`Build and Save…`}</em></strong>{` to create the BAR file.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "38.888888888888886%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAABBUlEQVQoz5WRb0+DMBDG+/0/lfGNRsP0nTFzDuigCwgMcPR/Hw+Gkxljsia/3F1799y1ZUII1HWDpmkmK5WCNRbBOoBQ2sBQfIG1KPse71WFTg5wzlGqJ+vBEs6xy3KUdDhSk3BefSDKUtztYphBTk2kPKFGn7hNY0RU+5rtwVOOnAZr2xYsSmI88Rgr4iHe4H67xqrIIeQncmK5wmxf+gbboZt8pS0OJNQRWmuwR54gSjZ4qwooozFQd4RwFvHkhxk/7/NjB0nXDlMcLpqyG8GxLvYQffszyVy8FFuyzPsNez6UaJ05TeP9n0nXwI7WQHuH/9ZVgoYecvy56fekPPMdXzv1F0ueblEw0wrFAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 31",
        "title": "ACE Toolkit integration with ES Configuration Step 31",
        "src": "/tech-academy-apac/static/368ca1f742758734af50c8c7f6656c5b/3cbba/2021-09-19_08-04-43.png",
        "srcSet": ["/tech-academy-apac/static/368ca1f742758734af50c8c7f6656c5b/7fc1e/2021-09-19_08-04-43.png 288w", "/tech-academy-apac/static/368ca1f742758734af50c8c7f6656c5b/a5df1/2021-09-19_08-04-43.png 576w", "/tech-academy-apac/static/368ca1f742758734af50c8c7f6656c5b/3cbba/2021-09-19_08-04-43.png 1152w", "/tech-academy-apac/static/368ca1f742758734af50c8c7f6656c5b/8b438/2021-09-19_08-04-43.png 1525w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 14
    }}>
      <li parentName="ol">{`You can dismiss the notification window reporting the result clicking `}<strong parentName="li"><em parentName="strong">{`OK`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "550px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "37.84722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAABRklEQVQoz33R2UrDQBQG4Lyrr+S1zyCtIC2tCiIiWKw0SdMsbUzMOmuTev17MjWhuF18/DPJOQdmxgqKEIGM8NEeoBuFpt1j32iTu3gL214h2oZYey6C0IfS8l9WVhZwNx58P0AYRdToUWOEDe29jY8sz1GUFSlNVnVN2K9qYilWoCPr3KSocsiTfav5keqxH5qv1JIGTmyF27XGTcc95sxVRGNOZo4azP9C9VOas4joyOG7QJTxQZgJ5KVGWWjsaB3nEnEmTW6zrravFwPzneYkBacjC4aOJK2kn0WK89UjJomPnJVI6QrSuiA5+lot+bA+JTkdmTEGxjiOycA5x72/xtndGBfOAlPfxch5xaVv4yHdQXNhHkpKCSGE0fX3a6sb8N1BKfCqwthZ4tpe4mr5jJH9gqc4osdieEsSU9cPqenl+95PpxRKvJg4ragAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 32",
        "title": "ACE Toolkit integration with ES Configuration Step 32",
        "src": "/tech-academy-apac/static/7e1867e788d1343161d026f40359b9c0/50322/2021-09-19_08-11-35.png",
        "srcSet": ["/tech-academy-apac/static/7e1867e788d1343161d026f40359b9c0/7fc1e/2021-09-19_08-11-35.png 288w", "/tech-academy-apac/static/7e1867e788d1343161d026f40359b9c0/50322/2021-09-19_08-11-35.png 550w"],
        "sizes": "(max-width: 550px) 100vw, 550px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 15
    }}>
      <li parentName="ol">{`Before we head to the `}<strong parentName="li">{`ACE Dashboard`}</strong>{` we need to do a final step. We need to create a zip file from the `}<em parentName="li">{`Policy Project`}</em>{` we created earlier in this section. For that you need to navigate to the folder where your `}<strong parentName="li">{`ACE Toolkit`}</strong>{` workspace is located (in my case that use Mac it is located at /Users/`}{`<`}{`your user>/IBM/ACET12/`}{`<`}{`you workspace>) and use your tool of choice to compress the folder where the policy project is located. The following picture shows a possible option.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "782px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.958333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABoUlEQVQoz52S22rbQBRF9f+fYdpAAoFCQ/tYaBI7obTGWI5jWbYiWSPJt9hSZckaWVo98aWF0gbah8U+c2bPZs4wRrXTxKsFVVVR1xyoalkf2DfQFFlCpTOp6wN1IVoJO+oyP/YrjMtOTOPThLYV0HenmE7EQC2xwjV2uML0Vlzcx5w3l5zfLjhrxrxpprxtCaJnzYSL1jONm++8b2cYw9mG3nhK5+GRtmnS7vWwJxNGvr/H8nyGas04SBiJOtEGZ7YV8gPTjHGYMJ7m+MstBvWOqtzijQd4oz6rmc96rlgJ8UJJ7aO3m/1oYpTJtOjvlD/V0LokzTLe3Xs0rn2uugkfujEfzZjLtvD1mSRNKbRmWxSv8uIxyrIkyzM+d564uhty+zjnzloKC24GS1qDGakEavEVx0N/RPb0KTDPc2zrgX73G5F6YjkPWEyVqGIxU/8X2LcsbMclimaEkSKIQlQQ4PmTfw/cSKBrdgntL/QmXR6sEGfkSGjA5BR4PPQa+tcbysj9Hq5tylexGTkK13Xlhgpf+aSblBff326nTyqeH0Vr8lHnaIWaAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 33",
        "title": "ACE Toolkit integration with ES Configuration Step 33",
        "src": "/tech-academy-apac/static/a4ee6d80723fd69ca11c4c9ef452655c/699e3/2021-09-19_08-24-49.png",
        "srcSet": ["/tech-academy-apac/static/a4ee6d80723fd69ca11c4c9ef452655c/7fc1e/2021-09-19_08-24-49.png 288w", "/tech-academy-apac/static/a4ee6d80723fd69ca11c4c9ef452655c/a5df1/2021-09-19_08-24-49.png 576w", "/tech-academy-apac/static/a4ee6d80723fd69ca11c4c9ef452655c/699e3/2021-09-19_08-24-49.png 782w"],
        "sizes": "(max-width: 782px) 100vw, 782px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 16
    }}>
      <li parentName="ol">{`Take a note where the zip file is located because we will use it in the next section.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "782px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.958333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABM0lEQVQoz6WRzVLCMBSF8/qOyii6c+UTOC4ERzeufAflzxEV5Ke0QJvcpMnxJqRAXTG6+Ca35+ac3vYKRRqzeQJrHRwAU1poU0cqjSxbYp0X234hFUiXjEFRqK0uuvMVev0uZuN3rNIpYCXHlj46wrWTyLMp1r5f5rEfsQpynXCtw7O4fk5wdPOGs9s+Lu6GuHrKcNxKcdKuyHDaSnDeGqPJNNpJ0Pydxn2Gy8cFmu0Jmg8pe5cQk5QwnGt8Lgw+EoPBt8LLl6zRGUm8TSnQGe36r0xvrDCYELp8p89e4ayBswRXEo/POL35VH+GOp42sq/9hn1Caw1FFCBekFQq/HC/rEo/FOKsEEghjODrvCh4mzlvzGx03z+E6Bc1YxS3Lzk0rBa4N+F/2U1YTfVHKq/P+gFRIv4da/d0AgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 34",
        "title": "ACE Toolkit integration with ES Configuration Step 34",
        "src": "/tech-academy-apac/static/e9d82bb3b916c9334f0a300b0631c0f2/699e3/2021-09-19_08-26-38.png",
        "srcSet": ["/tech-academy-apac/static/e9d82bb3b916c9334f0a300b0631c0f2/7fc1e/2021-09-19_08-26-38.png 288w", "/tech-academy-apac/static/e9d82bb3b916c9334f0a300b0631c0f2/a5df1/2021-09-19_08-26-38.png 576w", "/tech-academy-apac/static/e9d82bb3b916c9334f0a300b0631c0f2/699e3/2021-09-19_08-26-38.png 782w"],
        "sizes": "(max-width: 782px) 100vw, 782px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`Now we can move to the next phase.`}</p>
    <hr></hr>
    <h2>{`4 - Create Configurations in ACE Dashboard`}</h2>
    <ol>
      <li parentName="ol">{`Back to CP4I Platform Navigator, open the `}<strong parentName="li"><em parentName="strong">{`ACE Dashboard`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABsklEQVQoz3WSTY7UMBCF+wBIqJk4sR3np5PY+fN0p5u0RrNhYIXEhjMgseQInIBLP6pKJKNZsHiyXe189V65D3meg1UUhcg5hyzL/qMUmS2QqSP08R3SNEWqPpCOyLSGLUscpEgq6VBVlUCVUiKub6sAtYFyA5L1Bx6+/4YzKVz4Au0/E/RB7h627iEEgXJxHEe0bbvXg/eyTzONymmo51+ovv3BGl8Q5q84P/2EMTmssa9AhnFcTdbZpTFG4MZamNxCJQmdE+RFhbLIKfJ7AtCIrENXUdMmYvTLK5Djiot/I6jrGg25LHJqMvWoei+NcoLzzE+nVu4URSkyNA7WYZuPp1h8kV1ZcjfNj5jjI/quQxsnhE8vaK8fEYYBXdthva9Y1xV936Npmt3IG6CleBKTgAzrfEDHQHLqp5k0EawldyfEGHE+n+X3uj7t/4Q9Mnfi2Emi4MjpMN/QhQk9PQo3G8eZ9r3A2dEwRXg5NxJ9B25WGcaPsjmc4gX9MO2A6/WKZVkwcGRydblccL/fZeXzHpk/ZvErc2R+ZV754kJi5+yQQdt+i3y73aQJ14zRwvkLwAYSDvb975EAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 19",
        "title": "ACE Toolkit integration with ES Configuration Step 19",
        "src": "/tech-academy-apac/static/1c54480e4bd8eb82c171944e3cb48e64/3cbba/2021-09-18_13-19-50.png",
        "srcSet": ["/tech-academy-apac/static/1c54480e4bd8eb82c171944e3cb48e64/7fc1e/2021-09-18_13-19-50.png 288w", "/tech-academy-apac/static/1c54480e4bd8eb82c171944e3cb48e64/a5df1/2021-09-18_13-19-50.png 576w", "/tech-academy-apac/static/1c54480e4bd8eb82c171944e3cb48e64/3cbba/2021-09-18_13-19-50.png 1152w", "/tech-academy-apac/static/1c54480e4bd8eb82c171944e3cb48e64/0b124/2021-09-18_13-19-50.png 1728w", "/tech-academy-apac/static/1c54480e4bd8eb82c171944e3cb48e64/277bd/2021-09-18_13-19-50.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Click on the `}<strong parentName="li"><em parentName="strong">{`Wrench`}</em></strong>{` icon to navigate to the `}<strong parentName="li"><em parentName="strong">{`Configuration`}</em></strong>{` section.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABnklEQVQoz21R207jMBDNT/MRaCulFS/7DFWhofQbkJCQeGKFtFThIujuQiktbZw4jp1LDzMTUsIKS0dnZnw8novX+dHBeDxGv9/HYDDA4PBQeDgcIggCYcZoNCIOiE8kfnwcIKD40VFAb0hL/pA03s/9A/BxLsdsvsAqUlCJhsksXF6gOcZkwipaCefFRrhiu9rK4O10dvGUaSwXS8xmL1i+vUEphfV6LYhVhMe/c1z+usJFuMLJ6T3U6hWXVxPRRVFEHAkzvD2/i3hTIpw/wxoDrTWSJNmycxanZ+e4vXtA+OTw+4/D4uUfptMpsiwTTUIdNXrP73alVKlGLj8RxzGstZhMrhGGNyhyi1TTSFQsd8l/ek7q+b4vCSMqn3/kBIw0Tb/4hqpnv4m1/TQ1rQr9ukL+0dBlVVXbJbk83w6bbY41x1pH2noxRVF8Jux+tMztliTYbEhEKClx/aCOlWVJmy2QU2K2M6ncic9oVVi3vKYNJTqVVg0h0Tzo2uZYM1MGP1YfM9Raf1mk1+v16hlSQt0e8DcD/w7te87xDhvx5qVALNM+AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 20",
        "title": "ACE Toolkit integration with ES Configuration Step 20",
        "src": "/tech-academy-apac/static/b6927b06f33a355f8bdec9587d85f4b1/3cbba/2021-09-18_13-25-09.png",
        "srcSet": ["/tech-academy-apac/static/b6927b06f33a355f8bdec9587d85f4b1/7fc1e/2021-09-18_13-25-09.png 288w", "/tech-academy-apac/static/b6927b06f33a355f8bdec9587d85f4b1/a5df1/2021-09-18_13-25-09.png 576w", "/tech-academy-apac/static/b6927b06f33a355f8bdec9587d85f4b1/3cbba/2021-09-18_13-25-09.png 1152w", "/tech-academy-apac/static/b6927b06f33a355f8bdec9587d85f4b1/0b124/2021-09-18_13-25-09.png 1728w", "/tech-academy-apac/static/b6927b06f33a355f8bdec9587d85f4b1/277bd/2021-09-18_13-25-09.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Once you are in the `}<strong parentName="li"><em parentName="strong">{`Configuration`}</em></strong>{` window, click on `}<strong parentName="li">{`*Create configuration`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABPElEQVQoz51R207CQBDdf/Un/AaMFEx84VlNhRYSePE7fDY+mN7onZYqD4XjnglbkdiQuMnJ7OnOnDkzVTeDAZbLJWzbxmw2g+u6cBznIpj3NJ3C0XHhzjGfL7BYraAeHm3w7Pd7/OfkZ1zd3U+0WIv1eo08zwVZlgkMT5LkFzc5dVHiLQpw/ezhahLi5TWBGg5vsdvt4Hke0jQVUCAMw44HQSANDe/yNHIt/BHFePcjxLqRGo1GYpUFVVWhaRpst1txsNlshNd13b2dg7lfn42g0XdlWZbsj45YZIrjOJbRyC+hOtbwLoKHw0HGoiN25CPHpiA5ExlP0SeuLD0yHVKQQkaQOyrLUjhjURQSCTbuFzw6jKLoZwQtSAHjhE7Z4PTv/yXGfDUej9G2LXzf7z5SkIVmL+fj9o1M998YGuJa2z3tEAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 21",
        "title": "ACE Toolkit integration with ES Configuration Step 21",
        "src": "/tech-academy-apac/static/f30d9e1e6a21e6c1079500fc15320db0/3cbba/2021-09-18_13-26-13.png",
        "srcSet": ["/tech-academy-apac/static/f30d9e1e6a21e6c1079500fc15320db0/7fc1e/2021-09-18_13-26-13.png 288w", "/tech-academy-apac/static/f30d9e1e6a21e6c1079500fc15320db0/a5df1/2021-09-18_13-26-13.png 576w", "/tech-academy-apac/static/f30d9e1e6a21e6c1079500fc15320db0/3cbba/2021-09-18_13-26-13.png 1152w", "/tech-academy-apac/static/f30d9e1e6a21e6c1079500fc15320db0/0b124/2021-09-18_13-26-13.png 1728w", "/tech-academy-apac/static/f30d9e1e6a21e6c1079500fc15320db0/277bd/2021-09-18_13-26-13.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`In the wizard click on the `}<strong parentName="li"><em parentName="strong">{`Type`}</em></strong>{` drop down box to select `}<strong parentName="li"><em parentName="strong">{`Truststore`}</em></strong>{` to upload the Event Streams certificate.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABiklEQVQoz42RW0/CQBCF+8/hGSOgMT4aE1QuBYnIb/DFxEdTMaCES7n0ThtKaTnu2bgEiSZuMpk57cw3M7vaSaGATqeDWq0GXdfRarXQbDb/tHvxv6E3UKuL/KaOh3YbV/Uqrht1PHa70G5u78CTZRn+c9xfviXCZtkWC2Ha+cWlhM3ncziOI822bWlKL5dLqT3XhWFO8PL5gcFoBHNpwbIdhMEKvuthJPK0YvEUcRxjPB7DsixpBJimudfT6VQ2ZOwIwPOgjyfjFf2ZCduy8dZ7x2QyReCH0MrlshybBUEQIIoihGEoJ/J9X+rVarX/F0UhkniDzSZBmmaIhR8LmOf52CRi5VKpJFfmRCxSxYvFQq5LfWxsyGZJQuhWDpSmKbbbb+But5NrMYnJBHJtAqkVRMW8IsJohKiY0D1QTaiAvC/P86Smd8WDKE8ga7gZvTqMfwDVSgSyUE3EWL06Gx1Cjo94lDPZiXd2CCRAaU6mpluv16hWq8jn88jlcqhUKhgOh+j1ejAMA1/m/eBqDMisYQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 22",
        "title": "ACE Toolkit integration with ES Configuration Step 22",
        "src": "/tech-academy-apac/static/8cf46eb2bcdc91eb2ecae0322691d189/3cbba/2021-09-18_13-33-56.png",
        "srcSet": ["/tech-academy-apac/static/8cf46eb2bcdc91eb2ecae0322691d189/7fc1e/2021-09-18_13-33-56.png 288w", "/tech-academy-apac/static/8cf46eb2bcdc91eb2ecae0322691d189/a5df1/2021-09-18_13-33-56.png 576w", "/tech-academy-apac/static/8cf46eb2bcdc91eb2ecae0322691d189/3cbba/2021-09-18_13-33-56.png 1152w", "/tech-academy-apac/static/8cf46eb2bcdc91eb2ecae0322691d189/0b124/2021-09-18_13-33-56.png 1728w", "/tech-academy-apac/static/8cf46eb2bcdc91eb2ecae0322691d189/277bd/2021-09-18_13-33-56.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`In the next window enter the name of the certificate you created in the previous section (`}<strong parentName="li"><em parentName="strong">{`es-cert.jks`}</em></strong>{`), then a brief description if you want to. In my case I used `}<strong parentName="li"><em parentName="strong">{`es-demo JKS certificate`}</em></strong>{`. Finally click on `}<strong parentName="li"><em parentName="strong">{`Drag and drop a single file here or click to import`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABb0lEQVQoz42S62rCQBCF88j6LP5QhNA3aBWMSn2BlkL/FCvUxiI20dyvXnI9zqwkaC2tC8PsZjPfntmzUqvVwmQyQb/fh6IoGA6HV1F95zwejaAMBujR/wPKI1rzHucxcaT7hx54FEWBW8b6n31Jlu+Q5zkMw4DjOHXYtl3PTdOES3ltW3hafeFx/o43bYUojhFFEWLKHLvdDlKn08HhcICmaTXEsixsNpsaqK912ARdmQZev5d4WS7wrH7ACH2UWY6E6pmRpimkbrcrpLKKMAyx3W7FaQwKgkCsWQWHH0eYOybmlgHbdWH6HszAR0od8ijL8gTk+9N1XQC5kLNok4oqmGiNYk+HqY4F1bWwoPik+T5LiXbyoQYyoCpkILfteZ5Qew7lvSLLrsxgdRcK2ZRbgBx8X1zDZnKuYBdANsX3fQE4b/k3hX8+m8oUVsgmVEA2hQ/4CUuSBLIso9lsotFooN1uQ1VVTKdTzGYzHAGCPuOxeBbnFgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 23",
        "title": "ACE Toolkit integration with ES Configuration Step 23",
        "src": "/tech-academy-apac/static/645e5a7b437cb028ae540c9aae68481a/3cbba/2021-12-22_05-30-48.png",
        "srcSet": ["/tech-academy-apac/static/645e5a7b437cb028ae540c9aae68481a/7fc1e/2021-12-22_05-30-48.png 288w", "/tech-academy-apac/static/645e5a7b437cb028ae540c9aae68481a/a5df1/2021-12-22_05-30-48.png 576w", "/tech-academy-apac/static/645e5a7b437cb028ae540c9aae68481a/3cbba/2021-12-22_05-30-48.png 1152w", "/tech-academy-apac/static/645e5a7b437cb028ae540c9aae68481a/0b124/2021-12-22_05-30-48.png 1728w", "/tech-academy-apac/static/645e5a7b437cb028ae540c9aae68481a/743a9/2021-12-22_05-30-48.png 1911w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`Navigate to the folder where you craeted the JKS certificate in the previous section and select the file and click `}<strong parentName="li"><em parentName="strong">{`Open`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "35.06944444444445%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsTAAALEwEAmpwYAAABI0lEQVQoz11Sy06EQBDk6z34Bx5MvPsDGq/Gi1GTzbLKYxEQs4ZVkOHNPMrpcQdxO6lJM11d3dONs37ZIk0SQAqNCVAc1l5bhl5y9CNH3TQQQqIZlYkppWZwznVMQEoJZ7UJ4IchHtI93PcSweeAqGzhfu9x85GC8XEWoATGGBotfixq4axcD37g4/wuwOm1j5OrCBf3MXYdmzslIhkJVlWFPM+Nv4xZ31k/6w59j+gH/BHkgmwFu65DXdfGN1F9tIKDK/kr6PkhomgLQQRFSQQ1V56myYjYJ9E3wYzgwLn92iHtauM7cRwjy7J/T7Ago3kVRWGGfmx0Nw4DBl3gscwx6cU6id4wCfZ9byovRW2SFTteADUxjDpH/wmXmzecPaX4AQVgHQ0vWw+rAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 24",
        "title": "ACE Toolkit integration with ES Configuration Step 24",
        "src": "/tech-academy-apac/static/7217c5ee090e5d26f761e1adbc1f30ed/3cbba/2021-12-22_05-45-18.png",
        "srcSet": ["/tech-academy-apac/static/7217c5ee090e5d26f761e1adbc1f30ed/7fc1e/2021-12-22_05-45-18.png 288w", "/tech-academy-apac/static/7217c5ee090e5d26f761e1adbc1f30ed/a5df1/2021-12-22_05-45-18.png 576w", "/tech-academy-apac/static/7217c5ee090e5d26f761e1adbc1f30ed/3cbba/2021-12-22_05-45-18.png 1152w", "/tech-academy-apac/static/7217c5ee090e5d26f761e1adbc1f30ed/4c487/2021-12-22_05-45-18.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Finally click `}<strong parentName="li"><em parentName="strong">{`Create`}</em></strong>{` to add the TrustStore Configuration.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABJ0lEQVQoz62RSWvDMBCF9aNND4HeYuOloZhAUyh0uxXaW2/5OSYmtnEWr7Gt5LVPVMKXlBQq+KyR5HnzpBGWZSEMQ7iuC8/z4Pv+Reh/gyBQ3MxmuJ3PIZ5fXvGfQ3j+TAVJkmC322G/36t5zHa7NTHPN5uNisuyRFEUhqqqIOzpFF3XIYoiZFmmoHgcxypO0xSr1Qrr9dqc6wKHwwF936t8wlg4jqMcMpFV6rpWlehCrznTGff1mqJN06BtWwzDACmlQti2rQTpgkm8BqGTPM/NegxF6Y6utEuNEeSVxkkUpEu6Gu/THRPPNkUL8t0uEST6mhSW8ohBwmAE2QQ+tBb4zeF41Dh9f48/nP4uyEYsl0vcLe7x9LDA9eMnrt5bTN5qTD5KfAHQcdq2bDlLXgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 25",
        "title": "ACE Toolkit integration with ES Configuration Step 25",
        "src": "/tech-academy-apac/static/942c743d967507baa56970a01945191a/3cbba/2021-12-22_05-45-46.png",
        "srcSet": ["/tech-academy-apac/static/942c743d967507baa56970a01945191a/7fc1e/2021-12-22_05-45-46.png 288w", "/tech-academy-apac/static/942c743d967507baa56970a01945191a/a5df1/2021-12-22_05-45-46.png 576w", "/tech-academy-apac/static/942c743d967507baa56970a01945191a/3cbba/2021-12-22_05-45-46.png 1152w", "/tech-academy-apac/static/942c743d967507baa56970a01945191a/0b124/2021-12-22_05-45-46.png 1728w", "/tech-academy-apac/static/942c743d967507baa56970a01945191a/e957c/2021-12-22_05-45-46.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`Now we will define the Configuration to store the credentials selecting the `}<strong parentName="li"><em parentName="strong">{`setdbparms.txt`}</em></strong>{` type from the drop down box.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABg0lEQVQoz42R207CQBCG++ZwjVHAGF+gCtVSNMgzeO2FFwhiwECbng+0gZ743ZlkCRBN3GQyM7s73/yzq1y0WhiNRtA0DbquwzAMDAaDX80Q9mwM+Z72oIk9HU/DIfr6Izo9FS/jMZS7+x5o1XWN/6zoj30fe5hVDuX65pZhtm0jCAI23/fZZO66LuehiD+sNV7nM0wWC9iuJ848hGGE0A/wbTtQrq4usdvtsFqt4HkeGwEsyzrkpmlyQ4ojAX1fLvH2NYcfhmLPx2z2Ke5YSJIUSqfTYclUkCQJsixDmqasKI5jzjebzclZvs3ZqqpGnpdYr01EcYKirKC0220emRRRkSx2HIfHpfzc0izlZkVRoCxLFlRVFccM3O/3PBZdIgUEpLEJSDlDhJcxPRHBJFDGBD0ApUIJ5PeKIs7Jh+K9pCcg1dBk5OWi+AQoRyIgFUpFFMtfp0bHkPOldLtd7kRvdgwkgMxJmVS33W7R7/fRbDbRaDSgqiqW4ten0ykmkwl+AAsE4If65uQyAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 26",
        "title": "ACE Toolkit integration with ES Configuration Step 26",
        "src": "/tech-academy-apac/static/c8975529966cc1462c3865d8f8c35865/3cbba/2021-09-18_13-47-42.png",
        "srcSet": ["/tech-academy-apac/static/c8975529966cc1462c3865d8f8c35865/7fc1e/2021-09-18_13-47-42.png 288w", "/tech-academy-apac/static/c8975529966cc1462c3865d8f8c35865/a5df1/2021-09-18_13-47-42.png 576w", "/tech-academy-apac/static/c8975529966cc1462c3865d8f8c35865/3cbba/2021-09-18_13-47-42.png 1152w", "/tech-academy-apac/static/c8975529966cc1462c3865d8f8c35865/0b124/2021-09-18_13-47-42.png 1728w", "/tech-academy-apac/static/c8975529966cc1462c3865d8f8c35865/277bd/2021-09-18_13-47-42.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`In the next window enter the name of the configuration. In my case I used `}<strong parentName="li"><em parentName="strong">{`cp4i-esdemo-scram-credentials`}</em></strong>{`. Followed by a brief description i.e. `}<strong parentName="li"><em parentName="strong">{`Credential to connect to es-demo using SCRAM`}</em></strong>{`. Finally use the following information as a reference to enter the data in the text box.`}</li>
    </ol>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Resource Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`User`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Password`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`truststore::truststorePass`}</em></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`dummy`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`<`}{`Password obtained in step 10 of section “Create SCRAM credentials to connect to Event Streams”>`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{`kafka::aceflowsSecId`}</em></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`<`}{`Name of user created in step 3 of section “Create SCRAM credentials to connect to Event Streams”, i.e. `}<strong parentName="td"><em parentName="strong">{`ace-es-user-scram`}</em></strong>{`>`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`<`}{`Password obtained in step 7 of section “Create SCRAM credentials to connect to Event Streams”>`}</td>
        </tr>
      </tbody>
    </table>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB6klEQVQoz5WRPW/TUBSGPZWtNBVCoXWbQqEw8LGgrhlSqepfgL8RsZc2UWxjlCxxKFX6ITYEA4G2S9Q0SkC0UxkYEAgkuzaO7dj5sJAjpJd7LDkFARJc6dW55/qe577nmEun0ygUCsjlchAEAaIo/lWSJEFiMZ/PQ1GKKBaLUEolPGJaW1/H440NcJtb2/jfpektvNrZQ6PRQLPZRK1WQ7VaxdHhIThBlMNLpmnC8zx0Op0w/izXddFh0W63ceyY2K3u46Eko6QoYXckWZZRLpfBZVZXEQQBVFWFZVmhCK7rerhvtVrQNA0WO/tonODtl094Z57A8ftoB99+c89ls9lwQ4Xdbhe+76PfZ5eZmyinGKrXw3vrK96on3HEwMe6Cs1r/xlIjqiox4pI5M5xnGHus0csz8UH18az13WITzax9vwpyjsv8PJgH5VKBQf1Oms5kxkCaX7kLgKSyygndx6bJa37zMTI2Fnwc5cxdW0OE1dmERsfRzKZ/DdgeEZi343vAe4JWYzFYphNJDDNT2EmcQnxCzxSC4u/AqOWKVK70QP0lymnOdNaeSBhZDIO/uZ18IkJzEyOIn7uDBZT86dAwzCG8yIgQSK3EdC2bQwGA6wsLzNn07hx+xYuLtzB+SUFsVQeV+9u4wcIgY3Yi6j8mwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 26",
        "title": "ACE Toolkit integration with ES Configuration Step 26",
        "src": "/tech-academy-apac/static/aadcd0935d9763e4d49f44b3c2106cdc/3cbba/2021-09-19_06-07-46.png",
        "srcSet": ["/tech-academy-apac/static/aadcd0935d9763e4d49f44b3c2106cdc/7fc1e/2021-09-19_06-07-46.png 288w", "/tech-academy-apac/static/aadcd0935d9763e4d49f44b3c2106cdc/a5df1/2021-09-19_06-07-46.png 576w", "/tech-academy-apac/static/aadcd0935d9763e4d49f44b3c2106cdc/3cbba/2021-09-19_06-07-46.png 1152w", "/tech-academy-apac/static/aadcd0935d9763e4d49f44b3c2106cdc/0b124/2021-09-19_06-07-46.png 1728w", "/tech-academy-apac/static/aadcd0935d9763e4d49f44b3c2106cdc/e957c/2021-09-19_06-07-46.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`Now we will create the Configuration for the Policy selecting the `}<strong parentName="li"><em parentName="strong">{`Policy project`}</em></strong>{` type from the drop down box.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABdklEQVQoz5WS20rDQBCG88Re9VIQpKlJ2ooFlV6qz9C7voE3xSu1eMC0zXlzaBOzTZr+7iwkRqSCCz+zM9n5+Hc2SqfTwWg0gqZp0HUdhmEcVL/fx/lgAN3Q5Vld1C6GQxydnuBYO8Pl1TWUm9s7/GeVB+pMKBVSdGMoC67rIo5jJEkiY1tRFCGJE0RxhJllYmZ+4Mk0YXk+/IAhjhIwFuLVdqCo3S622y0WiwV835ciuGVZcu95HlarFRzHQSByJgAP72+4f36E6ToIBcgUvfSdwEqv15MOqXG9XiPLMqRpijAMm5wiOac6iX9y8HyLsqyQ8wLz+Qs8n4EX5TeQHFHjZrORIneMsSZvK81SOYqiKLDb7WR/VVVyr6iq2gBrFzWQXNZ5W5xzCatFIyOVZfkb2HbYBtbuKeZ5Lt0QgOJ+v5cilz+A7SZ62RpOV6cZB0Eg41+rmaFt2w2AgOSufU2q1Y80nU4xHo+lJpMJlsslTPEbkb4Aky3Y8Lo7pW4AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 27",
        "title": "ACE Toolkit integration with ES Configuration Step 27",
        "src": "/tech-academy-apac/static/326fec11eddce4a530d5111961203a27/3cbba/2021-09-19_08-33-56.png",
        "srcSet": ["/tech-academy-apac/static/326fec11eddce4a530d5111961203a27/7fc1e/2021-09-19_08-33-56.png 288w", "/tech-academy-apac/static/326fec11eddce4a530d5111961203a27/a5df1/2021-09-19_08-33-56.png 576w", "/tech-academy-apac/static/326fec11eddce4a530d5111961203a27/3cbba/2021-09-19_08-33-56.png 1152w", "/tech-academy-apac/static/326fec11eddce4a530d5111961203a27/0b124/2021-09-19_08-33-56.png 1728w", "/tech-academy-apac/static/326fec11eddce4a530d5111961203a27/e957c/2021-09-19_08-33-56.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">{`In the next window enter the name of the configuration, i.e `}<strong parentName="li">{`*jgr-es-demo-scram-policy`}</strong>{`, a brief description if you want to, i.e. `}<strong parentName="li"><em parentName="strong">{`Policy to connect to Event Streams instance es-demo using SCRAM`}</em></strong>{` and finally click on hyper link `}<strong parentName="li"><em parentName="strong">{`Drag and drop a single file here or click to import`}</em></strong>{` to import the zip file we created in the previous section.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABYUlEQVQoz62Sy27CMBBF89F8AiCSQiXEhmXbb2CXL+iWSiz64pGQ9ztABDi5nbFqSIVUdVFLVzNj2dfHY2udTgfj8RiDwQC6rsMwjD9JrR0Oh7jjOBrhfjKB9vD4hP8cmm6MZOL7PrIsQ57nMraVpuklL4oCH66D+eoTy8BDRnVO4vndbget1+3ieDzCsiyEYSjF5o7jyDwIAmy3W3ieJ/M0ivFirWAu5nhevmPh2Jjba/hFBnE+Q+v3+5KQF/Mp+/1enpQkyaXmyOQ8f6A6K3JESYwojpFSXp1OELVA0zRXQybijWVZSjFdTBtUzSrKAgcytchsEbh4C328kioi41HXNV2517sYKgplyJSqbotbVBONIAPR1JJM6cawTdg2VPQcq6qCEAJnIuPIRkx3Y9jexC+rzPnq3OMoimT89duoHrque+0VGTLdj/59fw1+JNM0MZ1OpWazGWzbxmazkfoCpvLZLpCuKKQAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 28",
        "title": "ACE Toolkit integration with ES Configuration Step 28",
        "src": "/tech-academy-apac/static/41a13dedf197cad1592f38a76006b8fd/3cbba/2021-09-19_08-37-09.png",
        "srcSet": ["/tech-academy-apac/static/41a13dedf197cad1592f38a76006b8fd/7fc1e/2021-09-19_08-37-09.png 288w", "/tech-academy-apac/static/41a13dedf197cad1592f38a76006b8fd/a5df1/2021-09-19_08-37-09.png 576w", "/tech-academy-apac/static/41a13dedf197cad1592f38a76006b8fd/3cbba/2021-09-19_08-37-09.png 1152w", "/tech-academy-apac/static/41a13dedf197cad1592f38a76006b8fd/0b124/2021-09-19_08-37-09.png 1728w", "/tech-academy-apac/static/41a13dedf197cad1592f38a76006b8fd/e957c/2021-09-19_08-37-09.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 12
    }}>
      <li parentName="ol">{`Navigate to the folder where you saved the zip file in the previous section, select the file and click `}<strong parentName="li"><em parentName="strong">{`Open`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "35.06944444444445%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsTAAALEwEAmpwYAAABHElEQVQoz3WRXU/DIBSG+/9jvDTxwt/gL9iVXugSb6Zx/QSXzXZxa/q5USjwCtg2XdQ3eTkEOM8BjhcTgt1uC2gJQBnbCJxkj1WVu3nbcXRcQCmNlmu3prWe3Pc9pJRmX8F7D2NElOKJ7LFcUwRZCVKe8Pi1w6o4uGQ1JFrRjw2ybP8LOtp78yNEJMbdkuB6EeBqEeH2maAS7AI2Atd+gCAIL4H42bPB3DBBHEf4S2qAzFVVFYqimAqM8awkhH1ymCSglKCXygDMD5rBejzIOXeQuq4hhHC2axNwKPRwTJGxFl5CEmxNU+YV509smgZ5njuQ/fS57BnWdW7+Wh5xYGd4FpZmKRhjLmkOtRq7918TuM1RAvf+J25eNvgG2XEcKap4+SIAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 29",
        "title": "ACE Toolkit integration with ES Configuration Step 29",
        "src": "/tech-academy-apac/static/169415f658b7adc782c31e0ecf09c855/3cbba/2021-09-19_08-42-05.png",
        "srcSet": ["/tech-academy-apac/static/169415f658b7adc782c31e0ecf09c855/7fc1e/2021-09-19_08-42-05.png 288w", "/tech-academy-apac/static/169415f658b7adc782c31e0ecf09c855/a5df1/2021-09-19_08-42-05.png 576w", "/tech-academy-apac/static/169415f658b7adc782c31e0ecf09c855/3cbba/2021-09-19_08-42-05.png 1152w", "/tech-academy-apac/static/169415f658b7adc782c31e0ecf09c855/4c487/2021-09-19_08-42-05.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 13
    }}>
      <li parentName="ol">{`Finally click `}<strong parentName="li"><em parentName="strong">{`Create`}</em></strong>{` to save the configuration for the policy project.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABOUlEQVQoz61RTUvDQBDNfzagF29NaBIrhIL1IFI9iXj2kp8T2ny1adomNGkiz7ylE7cFwYMLb2d2d+bNmx3DNE34vo/xeAzHceC67p8gsZ7nwevt3WSC++kUxvzlFf+5DMedKCdJEhRFge12q6yOzWYz+HzP8xyr1Qq73Q77/V6BflmWMKzRCE3TIAxDZFmmQPLlcqn8NE2xWCwQx/HwzgKEkBB1XeN4PMKwbVspZCIDqqpSAVQhZ1oq472c1+u1iuEdibquUxgIqUhvgUqYJGcdUpSq2B0JBYZlWQOhqBBCUaCTsSgTfx3KJaGuUCcU9bSHwwFd26JqatS97TtFe8IZoZ7ETxdyts4/5mRp9VWg7ffuhK+fP4yi6KwtqrtsVYYUBAEeZo+YP81w+/yJq/ca128Vbj5KfAO6KtnbTq3o+wAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 30",
        "title": "ACE Toolkit integration with ES Configuration Step 30",
        "src": "/tech-academy-apac/static/38b23fb72b805da75478048bbc9b1f0b/3cbba/2021-09-19_08-43-57.png",
        "srcSet": ["/tech-academy-apac/static/38b23fb72b805da75478048bbc9b1f0b/7fc1e/2021-09-19_08-43-57.png 288w", "/tech-academy-apac/static/38b23fb72b805da75478048bbc9b1f0b/a5df1/2021-09-19_08-43-57.png 576w", "/tech-academy-apac/static/38b23fb72b805da75478048bbc9b1f0b/3cbba/2021-09-19_08-43-57.png 1152w", "/tech-academy-apac/static/38b23fb72b805da75478048bbc9b1f0b/0b124/2021-09-19_08-43-57.png 1728w", "/tech-academy-apac/static/38b23fb72b805da75478048bbc9b1f0b/e957c/2021-09-19_08-43-57.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`We are ready to move to the final phase of the process.`}</p>
    <hr></hr>
    <h2>{`5 - Deploy BAR file using ACE Dashboard`}</h2>
    <ol>
      <li parentName="ol">{`From the `}<strong parentName="li">{`ACE Dashboard`}</strong>{` home page navigate to the BAR files section clicking the `}<strong parentName="li"><em parentName="strong">{`Document`}</em></strong>{` icon and then click `}<strong parentName="li"><em parentName="strong">{`Import BAR +`}</em></strong>{` button.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABIUlEQVQoz62RvU7DMBSF88yI7ggpUZQUVOABysDMKzAhBhYGhg5lSBs3sZ00rp2kBSEO11EESagQCK706Vr35/hYdg5HI5xNJgh8H2EQIPglp+G42fMpn5xfwLmcTmFj8/aK/wjnYBwi3pZ4iCPkeoO6qlCWZY+KatWgbgg7y1SGm6cYV3cZHpcKzpHn4Xm3g0xSCM7BhwgBxmKCNeduL0lT6FzifsZwfB3hdibheK6Lqq4RLRYQtNCFcwFJOWZJg2xr3ZmUhItc4MUIbEty6JJDYwzm83kr0ncoBcdyJRExSf09L2hZJRzroiBBcmgjy7JGWGvdwxiNQmmslWnOw35/1nwKKqW+fEbvY77pdfkQLMiuveGv9ATLH7rYhxWz+R0kjtd4jiq6dgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 31",
        "title": "ACE Toolkit integration with ES Configuration Step 31",
        "src": "/tech-academy-apac/static/248427897201a55928dbd01d2a43f5ad/3cbba/2021-09-19_08-48-03.png",
        "srcSet": ["/tech-academy-apac/static/248427897201a55928dbd01d2a43f5ad/7fc1e/2021-09-19_08-48-03.png 288w", "/tech-academy-apac/static/248427897201a55928dbd01d2a43f5ad/a5df1/2021-09-19_08-48-03.png 576w", "/tech-academy-apac/static/248427897201a55928dbd01d2a43f5ad/3cbba/2021-09-19_08-48-03.png 1152w", "/tech-academy-apac/static/248427897201a55928dbd01d2a43f5ad/0b124/2021-09-19_08-48-03.png 1728w", "/tech-academy-apac/static/248427897201a55928dbd01d2a43f5ad/e957c/2021-09-19_08-48-03.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`In the wizard click the hyperlink `}<strong parentName="li"><em parentName="strong">{`Drag and drop a BAR file or click to upload`}</em></strong>{` to upload the BAR file we created in the previous section.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABSElEQVQoz42SYUuDQBjH/X57uaHt1WhfZXjqUrcxHfON29jqY/gRgiAIgl5Y0VjhhGrklvrv7krTMuyBH3f38NzvnuNOaDQaaLfbaLVaEEWxFkmSeG2n08F6vUawDbANQxz2Ea5v7iAcd7tYnp7BcRzM5/N6FgvMZjMsVyuc3/q4uH/A5eYRIRUeojcIonjEZYZhYDAYVDIcDjnZnNU6kwmugie8xjHe44QSg4XQpO2PaBEhBJqmlVBVlY+EKFAUJc8TOh9R+eblGTFSZJGmKRU2m/xkWZZ/CRn9PhOqXNL/yjE527OPolyUkQt7vV61kHekQSbfuUwYFYXFDm3b5oWmaVaiGyZO9MJa1zEej0vC0pXrHuUnrNayLOx2O8T0MRhMliTJp3A6nfJT/+qwSCZkt6qKkvC/HWZi13Uxod/H8zz+yX3fxwdo+EC27r9R9QAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 32",
        "title": "ACE Toolkit integration with ES Configuration Step 32",
        "src": "/tech-academy-apac/static/408b0f23c0553ea51ee82134d6203d01/3cbba/2021-09-19_08-51-54.png",
        "srcSet": ["/tech-academy-apac/static/408b0f23c0553ea51ee82134d6203d01/7fc1e/2021-09-19_08-51-54.png 288w", "/tech-academy-apac/static/408b0f23c0553ea51ee82134d6203d01/a5df1/2021-09-19_08-51-54.png 576w", "/tech-academy-apac/static/408b0f23c0553ea51ee82134d6203d01/3cbba/2021-09-19_08-51-54.png 1152w", "/tech-academy-apac/static/408b0f23c0553ea51ee82134d6203d01/0b124/2021-09-19_08-51-54.png 1728w", "/tech-academy-apac/static/408b0f23c0553ea51ee82134d6203d01/e957c/2021-09-19_08-51-54.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Navigate to the folder where the BAR file was created (nn Mac you can find it at /Users/`}{`<`}{`your user>/IBM/ACET12/`}{`<`}{`your workspace>/BARfiles) and select the file and click `}<strong parentName="li"><em parentName="strong">{`Open`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "35.06944444444445%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsTAAALEwEAmpwYAAABFUlEQVQoz2WRz06EMBDGef+Dd+MTbHwCb3rxqK6r8qeawCLRRdFAWUppy2en2A27TDJh2vnm1xkmiBlDmqWIdr9Y5994zCu8VRzjODona4XEvutgzAjeT3c+T66Ugtba5g2CTZggZjFWDwUubguc3aS4XH9ghLFVOAJTQdM0aNt2ATX/3+D+KQR7TSgNjQEbvqPSCYYlsK5rlGXpYg/15oDUYRRHrnqvNK4+t9BmXIj9ubOjc84PQDJhx8067uIgjGPbIXMCKui1OupqGAY3IjnF9L+klJPmAFS4/irc2EHCEreU+YtzIHVTVZUDzTVeJ/reTffcVPiRAgHB8vccQgjXwSnQb+90Cd7loKxIYvWS4fxuiz8Wax1eAHQKrAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 33",
        "title": "ACE Toolkit integration with ES Configuration Step 33",
        "src": "/tech-academy-apac/static/dd30dcf0145e144ed6d02434e2de2a10/3cbba/2021-09-19_08-54-24.png",
        "srcSet": ["/tech-academy-apac/static/dd30dcf0145e144ed6d02434e2de2a10/7fc1e/2021-09-19_08-54-24.png 288w", "/tech-academy-apac/static/dd30dcf0145e144ed6d02434e2de2a10/a5df1/2021-09-19_08-54-24.png 576w", "/tech-academy-apac/static/dd30dcf0145e144ed6d02434e2de2a10/3cbba/2021-09-19_08-54-24.png 1152w", "/tech-academy-apac/static/dd30dcf0145e144ed6d02434e2de2a10/4c487/2021-09-19_08-54-24.png 1280w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`To complete the process click `}<strong parentName="li"><em parentName="strong">{`Import`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABSElEQVQoz42Sy26CQBSGeT+XGKwrU9+gW7eGASy3Rm00sQXS0HTRx+i7uMMIEeSif+dMCkFrQ0/yMQM58805w0i9Xg/D4RD9fh+KonQyGAxE7mg0wna7RRRF2O/3SNMUVVVBuh+P8Ra+Y71ew/f9ToIggOd5CMMQSZLgeDyiLEvUISnKnZBZlgXHcW7iuq6gntu2jeVyid1uhyzLhLAoCjFKMi//iScxxmAYxgW6rouRMQ2apjXfaU7SOI6R57kQEaJlWZbFzqqq/hISsxkJdTAumbWEtIZk19EIp9PpbSFVqBlQmXFRIa2h86M4n88NQkjnQYnUxi1My8aj2Xo3Tczn80bYlgph10+5hnIXiwXSwwFpkSPmrZ9OQFn9tLxarcSuf1XYphHyruqIkPEnXZ3TpfC/Fdbizcsr/M0zJsEXHj5KTD4TfAPQ10BRijxILAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 34",
        "title": "ACE Toolkit integration with ES Configuration Step 34",
        "src": "/tech-academy-apac/static/ca0ab99205782055fdb3567940b7d3ef/3cbba/2021-09-19_08-58-22.png",
        "srcSet": ["/tech-academy-apac/static/ca0ab99205782055fdb3567940b7d3ef/7fc1e/2021-09-19_08-58-22.png 288w", "/tech-academy-apac/static/ca0ab99205782055fdb3567940b7d3ef/a5df1/2021-09-19_08-58-22.png 576w", "/tech-academy-apac/static/ca0ab99205782055fdb3567940b7d3ef/3cbba/2021-09-19_08-58-22.png 1152w", "/tech-academy-apac/static/ca0ab99205782055fdb3567940b7d3ef/0b124/2021-09-19_08-58-22.png 1728w", "/tech-academy-apac/static/ca0ab99205782055fdb3567940b7d3ef/e957c/2021-09-19_08-58-22.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`After a moment the file will be displayed in the list of BAR files available with the status of `}<strong parentName="li"><em parentName="strong">{`Not deployed`}</em></strong></li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABHklEQVQoz62S3U6DMBiGuWnuADCALiQ788BdhidegScTzaLG4dgWgZaW/x8XD15blBkcRo1+yZP+fO3TfmkVVVXhOA4Mw4BpmrBtG5Zl/Zh+vXl8gsl0CuVsNsN/hmLak66TpCmqqjqglG1dvzGSb5sKQVzj4qqFHzZQDOMIL7sdoiAAo/QAHsddTkLFmBCyJ4oIWBxhsaQ4PedwlzkUTdOwTTjmD/e4265xuxki51zPg/vogQgh/YQUc0bR5BHqMhNCXYfPY1wubr4UXq98zL0VIrG5lwxvSxGEBGkqhIYQPjctNv5alMe6EnuYIBGEIcNTwBBTMii5p5dnmRDqQiiDc46iKEbJ3ym+oSzLD6G0j73ib9kLU/Ft5Al/5RUqHtQ7/fee3AAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 35",
        "title": "ACE Toolkit integration with ES Configuration Step 35",
        "src": "/tech-academy-apac/static/98aee2afd4ba77642c8677e03bed4b47/3cbba/2021-09-19_09-00-55.png",
        "srcSet": ["/tech-academy-apac/static/98aee2afd4ba77642c8677e03bed4b47/7fc1e/2021-09-19_09-00-55.png 288w", "/tech-academy-apac/static/98aee2afd4ba77642c8677e03bed4b47/a5df1/2021-09-19_09-00-55.png 576w", "/tech-academy-apac/static/98aee2afd4ba77642c8677e03bed4b47/3cbba/2021-09-19_09-00-55.png 1152w", "/tech-academy-apac/static/98aee2afd4ba77642c8677e03bed4b47/0b124/2021-09-19_09-00-55.png 1728w", "/tech-academy-apac/static/98aee2afd4ba77642c8677e03bed4b47/e957c/2021-09-19_09-00-55.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`Now navigate to the `}<strong parentName="li"><em parentName="strong">{`Dashboard`}</em></strong>{` section and click on the `}<strong parentName="li"><em parentName="strong">{`Create server  +`}</em></strong>{` button.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABc0lEQVQoz6WRvU7DMBSF88oMIJWhCyoNSVnKQIFHQGJiYUCo4gVAQhTaqgyA1B9Cfq6dOHbSw61bWhiKKhHp6H6+to+PHaeyW8Fx6wRuvY6G5+HQb8Dj6rO8NfJ9fz7PdaZms4nW6RmOWi04W3t13A0G+M/30u/h+uoSIongbFereA8DdMZDPE6G6H5OUOQaaZYhs1ILzTlXCnEqcc9r+x9j9IIRbjs9XLQf0H0dwzlwXXuKTgkoCkxNAZ2n0FpbGT3jnGUWrCxLJRBnElkucfMcYuec0H6K4dRqNWtI0RuMYYOiRCaGzDnKcso84gMkM6DkBFoRuM0BAr4JcWLN/QSljqA4lFPbXxgKiYJ3mcIg5WsZTrtiw+ELZIqTGuZyxsry7CmShFgCRGKVMIwjkBSIkhiCq0jnTJKYpeXkm4lZkF1DXIlWWhmGoW0IEsvJTdiOhVjWpWEURbaxiWyqn+Mfxo67+MtBECCO4z+U/EqzLuEX90nel0lHXn0AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 36",
        "title": "ACE Toolkit integration with ES Configuration Step 36",
        "src": "/tech-academy-apac/static/6ec1234301ddc56303ce33983d2fc665/3cbba/2021-09-19_09-03-00.png",
        "srcSet": ["/tech-academy-apac/static/6ec1234301ddc56303ce33983d2fc665/7fc1e/2021-09-19_09-03-00.png 288w", "/tech-academy-apac/static/6ec1234301ddc56303ce33983d2fc665/a5df1/2021-09-19_09-03-00.png 576w", "/tech-academy-apac/static/6ec1234301ddc56303ce33983d2fc665/3cbba/2021-09-19_09-03-00.png 1152w", "/tech-academy-apac/static/6ec1234301ddc56303ce33983d2fc665/0b124/2021-09-19_09-03-00.png 1728w", "/tech-academy-apac/static/6ec1234301ddc56303ce33983d2fc665/e957c/2021-09-19_09-03-00.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`This will start the deployment wizard. Select the `}<strong parentName="li">{`Medium Integration`}</strong>{` tile and then click the `}<strong parentName="li"><em parentName="strong">{`Next`}</em></strong>{` button.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "55.208333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAAB3ElEQVQoz31RTW/TQBD1v03SpEEQBC1ShDhw4ifAH0Bqiwri0BKpSJzJCXFoBdiB1E0de71ee9ffj5lVbaACRnqa1e7sm/dmnOFwiHuzGcbjCWGM6XSKO4Td3Qkmk79jRvX7e3t4SNh/cBeP7o/wlPKzx0/gzOdzmKJGGEkkSQKlFNI0Q9O0+FdcnJ/j9N0CH94vsDi7wMGZwcuTCO5KwRmORgjCGF++unBdF57nwft+iU0gIKX8BWoWU86yDB+XSxwevcLb10c4OF7ixZtrPD9c4dNnH87OzhhF2UDEMYQQFjFB3ajtIWMoqpEiQk6kbVNbtW2TA1UCNApak8LBYABjDNbrNbbbrVWTpqklZiKT5zBEELnfEKw8yCsfyeYKcv0D2yCgMSlkOiflxp6dEVnmYAImqqrKgufJKOlcGg0dUjN6Z8tV26KIhVWbUNOyLC34v8Nb5mASVtpSMZ9zUlbXNfKiIDsNEYbgNfE9R0kjyLWmpwYF11BYQlbYsVuLRMpg6/yZl1FRFmRXK1JNxJruMrIdR6FtyLUsgv/3CrvZdWBrKRVw5gXJ6w2E7yMmIuFfQtL87FtXQ5lHZAnZJhP+sdXfYJtwgx7a5ts1PWGnsP98G/9rdDOqLv8E1YQZqPfXdm0AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 37",
        "title": "ACE Toolkit integration with ES Configuration Step 37",
        "src": "/tech-academy-apac/static/6ebfb6aa685a04113299332a93cca30a/3cbba/medium.png",
        "srcSet": ["/tech-academy-apac/static/6ebfb6aa685a04113299332a93cca30a/7fc1e/medium.png 288w", "/tech-academy-apac/static/6ebfb6aa685a04113299332a93cca30a/a5df1/medium.png 576w", "/tech-academy-apac/static/6ebfb6aa685a04113299332a93cca30a/3cbba/medium.png 1152w", "/tech-academy-apac/static/6ebfb6aa685a04113299332a93cca30a/0b124/medium.png 1728w", "/tech-academy-apac/static/6ebfb6aa685a04113299332a93cca30a/4ea69/medium.png 2304w", "/tech-academy-apac/static/6ebfb6aa685a04113299332a93cca30a/21adf/medium.png 3258w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`In the next window click on the drop down box to select the BAR file we previuosly uploaded and then click `}<strong parentName="li"><em parentName="strong">{`Next`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABU0lEQVQoz5VSTU+DUBDkT/c3VD4LNfHas1cPXkxMo0lPXrVNjaYtbaQUEKRQ3kcZH6UlUEnUTSZvl53Mzm6QOp0OTNNEt3sBVdVgGAZ0XYemaaJWBNQKilLWluBbVh9904DVk2EaMnRDh3F5CWkwGKCIXIDy8v0t7odD3N3e4Ppxit4IuBrl4MeeJMvyIfGDEK4XwnF9kQf4jGJkhIBRCloDEd8cx8FyZePhfYa3NcHCJUgzwWUMUrFCEUmywzalAqLB95WbPM8b+amekxTxnjacF71KcJsIggBlHDsx6SPd4jnykTDaED6JUs6rvD5IKg5/WNkLEPgBSJohiL6wikKssxRkz1udNvLaMElVSsGJbeNpOsZY3ObFnmOycfEah0g5++HwfP36KylHh8uNdxBdeB5m7gZuHLc6aouG4OmGnPFW4rmLPwsWv8T5kUte/i+H30z36HuqHWRsAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 38",
        "title": "ACE Toolkit integration with ES Configuration Step 38",
        "src": "/tech-academy-apac/static/d2d1e9e598b73fc0c865c52dbf633d0f/3cbba/2021-09-19_11-37-28.png",
        "srcSet": ["/tech-academy-apac/static/d2d1e9e598b73fc0c865c52dbf633d0f/7fc1e/2021-09-19_11-37-28.png 288w", "/tech-academy-apac/static/d2d1e9e598b73fc0c865c52dbf633d0f/a5df1/2021-09-19_11-37-28.png 576w", "/tech-academy-apac/static/d2d1e9e598b73fc0c865c52dbf633d0f/3cbba/2021-09-19_11-37-28.png 1152w", "/tech-academy-apac/static/d2d1e9e598b73fc0c865c52dbf633d0f/0b124/2021-09-19_11-37-28.png 1728w", "/tech-academy-apac/static/d2d1e9e598b73fc0c865c52dbf633d0f/e957c/2021-09-19_11-37-28.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`In the next window select the 3 configurations we created in the previous section and then click `}<strong parentName="li"><em parentName="strong">{`Next`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAAByElEQVQoz21STU/bQBT0r+MH9BrBpQeuCG7NrSKJ7RCpnJBof0YvpVKQeiiHqiAOJCJBKI4THH8ljr+NHYb3NnaEolga7dvn3dmZ2ZWOT06gdM7QbDRw2myiJcuQSyiElqxAVlSoqgpFUdDpdFCv11Gr1XBwsI9Ph1+w9/krakenODv/Buni+yUSAH3HxP14hIFtIs0ypGmKMAyRZAUhF/M4TpDnOXRdx9XVb3Svu/h5a+HH3wi/Rjn4k1Q6lT/deMFI02CYJlzXheM4mE6nmFNtUm8ymQii8Xgs/iVJIg5IQw9F5GLoW4heM0jtdlsQxkGIOS0MfR9xFCMIAkEckMowioTaiMaorH1aJ0D7goB62SuKtxUkmbKJifDxZYL7pyH6ugaTiLzFAoZhYEGj53lirMDzj1gQ3larteW2ulb473mI//0e7p4G0IjItixoFIFt24KYa7bLtrm3jaIoygw3lgNhOeaLiNeWOSu2x3WlZrlcit42VhuFJaE7n8MiVbyZwflUc7bJNSvhQ5j44zrGhlBW17fMl2HSJr9UsEthpa66mJ0KG4oMh4o/gx5u+g+Y0ROxCLPZTOTFyjhDfjbc4ye0C1WG75dn0TwVDlicAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 39",
        "title": "ACE Toolkit integration with ES Configuration Step 39",
        "src": "/tech-academy-apac/static/29ed14101488dcfbb9287de096ecfa38/3cbba/2021-12-22_06-07-07.png",
        "srcSet": ["/tech-academy-apac/static/29ed14101488dcfbb9287de096ecfa38/7fc1e/2021-12-22_06-07-07.png 288w", "/tech-academy-apac/static/29ed14101488dcfbb9287de096ecfa38/a5df1/2021-12-22_06-07-07.png 576w", "/tech-academy-apac/static/29ed14101488dcfbb9287de096ecfa38/3cbba/2021-12-22_06-07-07.png 1152w", "/tech-academy-apac/static/29ed14101488dcfbb9287de096ecfa38/0b124/2021-12-22_06-07-07.png 1728w", "/tech-academy-apac/static/29ed14101488dcfbb9287de096ecfa38/e957c/2021-12-22_06-07-07.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`In the next page give your deployment a name, i.e `}<strong parentName="li"><em parentName="strong">{`jgr-es-api-scram`}</em></strong>{` and open the `}<strong parentName="li"><em parentName="strong">{`YAML EDITOR`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "55.208333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAABsUlEQVQoz4WSTU/bQBCG/ScjKqhyTQKJFdpLbpHonSNEqipVnNob4kB6zG8ohyqVCgUCjr/W6/WuP0DN25mNXaWolJUezezM7OtZzzq9Xg+j0Qhv9vcxJNzh0DIYDNDv9wmXfBeu+zftdhutVguvtrbQet3B9s5buIN3cMbjMXzfx9eLC1zN5yjCAFUUAg8VeP3Cv9dsNsPx8QQnHz/g/bmPgzPgcAo43W4HX6ZTHE0mOP38Ccvvc9zPv8G7/olUSkgh1vYJxhhUVYmyJHKFx0KiMhLO7u4eivIBORUUlNRFgYxEgssfEDfXyO4WKDhH8U3yPLeiRmsolSFVGjJVcDqdLrTJEfgB4jimpEJGHUSLW8SLBXQikNcCDVaIaPwsy5BZYcVX7tp/whtNQSZNU8QioQ8ZKC6uMU863RTUm4Kr1cqKNAn2AxqUItt0w/CBJEkIaWueFeS1KfhcRxzjOk22ILGy7vJFQfa5E95zEcPiQsTwliH8SFmieD3xFwU5EUXRn+fBMbae5xFLygn6xxIJ5e0Q6xv9t8MwDK2ooCck64O8T2jqabruytRDbM5w7W/dBBVKbKqJsQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 40",
        "title": "ACE Toolkit integration with ES Configuration Step 40",
        "src": "/tech-academy-apac/static/3fa41393fb3e9aee5a5e5de874ce2e2f/3cbba/yaml-editor.png",
        "srcSet": ["/tech-academy-apac/static/3fa41393fb3e9aee5a5e5de874ce2e2f/7fc1e/yaml-editor.png 288w", "/tech-academy-apac/static/3fa41393fb3e9aee5a5e5de874ce2e2f/a5df1/yaml-editor.png 576w", "/tech-academy-apac/static/3fa41393fb3e9aee5a5e5de874ce2e2f/3cbba/yaml-editor.png 1152w", "/tech-academy-apac/static/3fa41393fb3e9aee5a5e5de874ce2e2f/0b124/yaml-editor.png 1728w", "/tech-academy-apac/static/3fa41393fb3e9aee5a5e5de874ce2e2f/4ea69/yaml-editor.png 2304w", "/tech-academy-apac/static/3fa41393fb3e9aee5a5e5de874ce2e2f/21adf/yaml-editor.png 3258w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">
        <p parentName="li">{`Because of a known issue in Integration Server v12.0.5 with Kafka Nodes, we will use a previous version of the Integration Server. Let’s do it!`}</p>
        <p parentName="li">{`Change the `}<strong parentName="p">{`license`}</strong>{` value to `}<strong parentName="p">{`L-APEH-C9NCK6`}</strong>{` (A). And change the `}<strong parentName="p">{`version`}</strong>{` value to `}<strong parentName="p">{`12.0.4.0-r2`}</strong>{` (B). Then click `}<strong parentName="p">{`Create`}</strong>{` (C).`}</p>
      </li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "55.208333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAACFElEQVQoz5WQz0/SYRzHuXMwYJNCvsAX5Bs656FVbg6wtEtzEz30JwRMwC3NftjQ3Lp1qnVlMliXdGabrenU1tUD69BFV7baWiMDvnz5sSD01RfUyi7hs7322Z49z+t5vx9NMBhkfGKCUCisEmJsbKxBJBIhHA4fo743Pn6T23emmJ65T3R6lnt3J5maHOXBrRs8nJlFE41GKf+o8T0royh58nlZReFnrca/a39/vzG3trZYWVnlzcYqqxvbPFsrsrCWYye9h6aeMJNT+LDzmY+fvpDezbKbK5PJV5BlhUKhoD6k/KZcLpNKpVh8vsSr5SUWl98Se5Em+TLNux0FzehoCFkp8DX9je3t9ySTT3n0+Anr668pFItkMhmy2WyDXC7XmKVSiWq1SqVSpVopsleVqVVkSgUZTcDv53owgPuShwF3L6bTRk61tCBJEv39/Xi9Xvr6+o7h8Xhwu92H08PlgStcuNjD/PyCKgwEuDo4SItNoE1yIthERJsNs9lMa2srRqPxv5hMJrRaLbFY7EA4MjxMh8tJT3cXvSp2UUSwWLBarU1ht9sxGAzE4/EDoc/nwylaOX/WSXe7o5FQEAQsqrQZbOp5nU73l3BoCEObCUdXZ6Oq+VBWlzYjPhLOzc39SXjGIuBySYhqhSPZSRLq9XoSiQQavyq8NjLCOcmBW2qnp7MDsf6HJxDWW9XvbG5u8gsRCN35uB8iVQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit YAML Values",
        "title": "ACE Toolkit YAML Values",
        "src": "/tech-academy-apac/static/4057f70c3016b1db384e39544f25c0d0/3cbba/yaml-values.png",
        "srcSet": ["/tech-academy-apac/static/4057f70c3016b1db384e39544f25c0d0/7fc1e/yaml-values.png 288w", "/tech-academy-apac/static/4057f70c3016b1db384e39544f25c0d0/a5df1/yaml-values.png 576w", "/tech-academy-apac/static/4057f70c3016b1db384e39544f25c0d0/3cbba/yaml-values.png 1152w", "/tech-academy-apac/static/4057f70c3016b1db384e39544f25c0d0/0b124/yaml-values.png 1728w", "/tech-academy-apac/static/4057f70c3016b1db384e39544f25c0d0/4ea69/yaml-values.png 2304w", "/tech-academy-apac/static/4057f70c3016b1db384e39544f25c0d0/21adf/yaml-values.png 3258w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 12
    }}>
      <li parentName="ol">{`After a moment you will be taken back to the Dashboard page where you will see a new tile with your `}<strong parentName="li">{`Integration Server`}</strong>{` deployment name in `}<strong parentName="li"><em parentName="strong">{`Pending`}</em></strong>{` state, similar to the picture shown below:`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABb0lEQVQoz6VRy0rDUBDtR/cXGky6aSsK6k7BH3Cj6Nq1S6WiILWt2ia5uZPcRxKPc2+S0kJBwcBhTmZOzjzS6/f7GI3GCIIAYRhiOBwiiqI/wWkdJpMJTk7PMD46Ru/84hL/fZ6nT7i7vkImEvQOwsgnpSRoraGUYnSx4xqGa1YbD6ObXJ4X0KrA9HWO2/sp3uZr9AaDgTcscgFrrUdpC45mh69ywpfM8CEFMm5UWQVjNPBt8TgzOLwBHl6MMwy8IYl3VJVl1FC0RFka1PU3NH2i0IS1VhBZhoQkUtdIxTAqBUtQm5gdmJfOMGgmlJSjqmuUVckGmmPlueIVCzYQlqfhr50mNW46Xt2W3LRivYEypT/DZuVEpJC8VpoJEEcqGu5ykvksXmHJR1+wbpGsWSNZk0O4E5D0ekm0ZZgk/GO4wEkXPZfURomM143ZzIHaXKfpuMOOoTejxnSby/Y9b7Fbk5s67ZtwH7pJf82x4Q9qx+E969CXNwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 41",
        "title": "ACE Toolkit integration with ES Configuration Step 41",
        "src": "/tech-academy-apac/static/85ffd31c906b6fec06f183378943793d/3cbba/2021-09-19_11-47-40.png",
        "srcSet": ["/tech-academy-apac/static/85ffd31c906b6fec06f183378943793d/7fc1e/2021-09-19_11-47-40.png 288w", "/tech-academy-apac/static/85ffd31c906b6fec06f183378943793d/a5df1/2021-09-19_11-47-40.png 576w", "/tech-academy-apac/static/85ffd31c906b6fec06f183378943793d/3cbba/2021-09-19_11-47-40.png 1152w", "/tech-academy-apac/static/85ffd31c906b6fec06f183378943793d/0b124/2021-09-19_11-47-40.png 1728w", "/tech-academy-apac/static/85ffd31c906b6fec06f183378943793d/e957c/2021-09-19_11-47-40.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 13
    }}>
      <li parentName="ol">{`The `}<strong parentName="li">{`App Connect Dashboard`}</strong>{` is deploying the `}<strong parentName="li">{`Integration Server`}</strong>{` in the background creating the corresponding pod in the specificed `}<strong parentName="li">{`namespace`}</strong>{` of the `}<strong parentName="li">{`Red Hat OpenShift Container Platform`}</strong>{`. This process can take more than a minute depending on your environment. Click the refresh button in your browser until you see the tile corresponding to your deployment in `}<strong parentName="li"><em parentName="strong">{`Ready`}</em></strong>{` state as shown below:`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABdUlEQVQoz6VRTUsjQRTMj85fyLD5OKhBQb3tgn/Ay4qePXtUIi6Ims2GyUxPv/543TOWb3qSJYEgggNFVb8uaurN9Pr9Pg4ODpFlGYbDIcbjMUaj0ZfQeieTCaZHU5yenePw+AS9n78u8N3ncfaAm9+XqFSB3o/hKA21Jnjv4ZwTbHijPVjuAnMC+25mjIV3FrM/b7i+neH5LUdvMBikQGsUQggJMVhh3tG5ISz1CouqQCUvqoMDswfeA+5fGNMr4O6J28AsBZJ6RV0HQQNHfxEjo2ne4ekfrCfk0srSAsoUKENEdCuwKyEWNLySBNGxDcy6hpoM6qZBrKMEeOE6aecZVpoW7KRpBK01t6vLuWlq8TMcx/QZ/q9cqBJa1iorBRIm22ltNIw1uF/O8ZgvsRDfvMzFo8VjoLRCRTr5NdFWYFHIj5ELGbactO60kVmuFBbFCnZ93vbQWrfYCUxh1IVu65bbkBS0x6PXmvY13Ifd1vpT3wcgWuD8CfCEegAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 42",
        "title": "ACE Toolkit integration with ES Configuration Step 42",
        "src": "/tech-academy-apac/static/c6f0594dca2e2cc5ebf2518f9a8a3aea/3cbba/2021-09-19_12-21-31.png",
        "srcSet": ["/tech-academy-apac/static/c6f0594dca2e2cc5ebf2518f9a8a3aea/7fc1e/2021-09-19_12-21-31.png 288w", "/tech-academy-apac/static/c6f0594dca2e2cc5ebf2518f9a8a3aea/a5df1/2021-09-19_12-21-31.png 576w", "/tech-academy-apac/static/c6f0594dca2e2cc5ebf2518f9a8a3aea/3cbba/2021-09-19_12-21-31.png 1152w", "/tech-academy-apac/static/c6f0594dca2e2cc5ebf2518f9a8a3aea/0b124/2021-09-19_12-21-31.png 1728w", "/tech-academy-apac/static/c6f0594dca2e2cc5ebf2518f9a8a3aea/e957c/2021-09-19_12-21-31.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`Now is time to test everything is working as expected. Click on the tile corresponding to your deployment.`}</p>
    <ol {...{
      "start": 14
    }}>
      <li parentName="ol">{`The next window shows the API in started state. Click on the tile to get the detaisl.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA2klEQVQoz62RXQ7CIBCEuXQPoOmPtjX+HEA9mDG+GLVaC5S2GKvjQtMnX0SdZALJsh87wDzPw3S2QBhGGMcxkiRBTOun7s+nkwnS+RxsvVrC6In/iI2iyG54wVErhYpc1zW01k42PU3TgPlBAE3A3TVHpiRkVUFToXF0RX1SSrCh7+NBwG2eQ1DhyAuosoQkl45WlI4NCGh01zfotsVRcBu7JCtHGygLKPKhvWFzOSGTArkQHfDbCaMwtJH35wyK3qC/6ZvpLNBMaCQ4tzH7giv0DVgU3Wf8CnwB4gjh8kmT3ekAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 43",
        "title": "ACE Toolkit integration with ES Configuration Step 43",
        "src": "/tech-academy-apac/static/29941963c7f2e301e430d59348d0b094/3cbba/2021-09-19_12-25-00.png",
        "srcSet": ["/tech-academy-apac/static/29941963c7f2e301e430d59348d0b094/7fc1e/2021-09-19_12-25-00.png 288w", "/tech-academy-apac/static/29941963c7f2e301e430d59348d0b094/a5df1/2021-09-19_12-25-00.png 576w", "/tech-academy-apac/static/29941963c7f2e301e430d59348d0b094/3cbba/2021-09-19_12-25-00.png 1152w", "/tech-academy-apac/static/29941963c7f2e301e430d59348d0b094/0b124/2021-09-19_12-25-00.png 1728w", "/tech-academy-apac/static/29941963c7f2e301e430d59348d0b094/e957c/2021-09-19_12-25-00.png 1920w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 15
    }}>
      <li parentName="ol">{`In the next page navigate to the operation implemented in your flow (`}<strong parentName="li"><em parentName="strong">{`POST /contacts`}</em></strong>{`). Then click on the `}<strong parentName="li"><em parentName="strong">{`Try it`}</em></strong>{` tab followed by the `}<strong parentName="li"><em parentName="strong">{`Generate`}</em></strong>{` hyperlink to generate some test data. Review the data generated and click the `}<strong parentName="li"><em parentName="strong">{`Send`}</em></strong>{` button.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABZElEQVQoz61Sy07DMBDM/xe19AqHHoBL05RD/wBRUSGE4IRaaGlLSF8JcV5OnNdgO0mLRBAcWGskW7s7nllbaTQaULU+zs4v0O120ev1JFRVhaZp+3MdRL6q0fp9XA4GUDqdDv4zlKNmE7pDMDd0OMRB4PtYbNeYmTtkaYY4jv+EJEng815J+EZs3EwncDyPJ2KYEcXCd5GwGFEUgTH2I0Q+DEOkaSr3SqvVklLvV28ggQ9wVXrgwowjpLyBlsVCQR2qyPkSxHvC1+0GXhDIfZgWhUKh47r1ylgkL7eiEC8+KfoE4XFJ6PH5hZQiz3N5thMGnxdkWVZKyGWugoiZSzAmFhLuIBAI6UGhbduggrC0oFMPD1sDo8kTHidjTHcbsHJeFZaWube8iEg9YSGmoGV8RtO1gdnKwLv9IV/zYJnxX5DC2qwxfF7iai4ekUFpt9vfCPHF1m9xN7rG6eAWJ0Mq5/0JJxDsWiKZdEwAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 44",
        "title": "ACE Toolkit integration with ES Configuration Step 44",
        "src": "/tech-academy-apac/static/99853b68fc3b27afb6d03f060c185a73/3cbba/2021-09-19_12-44-47.png",
        "srcSet": ["/tech-academy-apac/static/99853b68fc3b27afb6d03f060c185a73/7fc1e/2021-09-19_12-44-47.png 288w", "/tech-academy-apac/static/99853b68fc3b27afb6d03f060c185a73/a5df1/2021-09-19_12-44-47.png 576w", "/tech-academy-apac/static/99853b68fc3b27afb6d03f060c185a73/3cbba/2021-09-19_12-44-47.png 1152w", "/tech-academy-apac/static/99853b68fc3b27afb6d03f060c185a73/0b124/2021-09-19_12-44-47.png 1728w", "/tech-academy-apac/static/99853b68fc3b27afb6d03f060c185a73/277bd/2021-09-19_12-44-47.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 16
    }}>
      <li parentName="ol">{`After a moment you will get a response back. If everything is OK you will receive a `}<strong parentName="li"><em parentName="strong">{`200`}</em></strong>{` response code indicating the request was successful and the same payload you sent plus some metadata including a timestamp showing the request completed few seconds ago.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABgElEQVQoz52SzU/CQBDF+fc5Ee6EEwkQoKbq0YvxaOLBiydQC9gu0A/a7vZj2z5nNlBjJNG4yS+7s9N9O/umnW63C8uyMBqNMJ1OsVgsMJ/PzTybzTAcDg3j8djkJ5NJC8e2bePavsKNbWFGOp3BYAAeTdPgP6OpNVQJ5Ke40+v1zOJwOCBJEuR5jrIsobVGlmUmZnjNcI4pigJ13eDh/g7j2ydYjzDnW8EwDKGUQlVVqJva7O08D6vVCo7jQAgB3/fNoZSI4xi60t+q5YsvCtL7UdYVXsQHgjRBRdVq2uccV87wHtv0BcwLfgjq04cs+Lzd4HV/wDb04R4jeEwcQcRHrKMAudbf/L8oeB4ZCQZxArFx8b5/h+u7CI+hebIk3DCALIvfBdsk+eOTTzuHfPSWiEgskwoyTZFLiT1Vq6g5f66woMZsoxCbD4GlWGMT7CAo9qiyHc1v/h5Klz+b0u/3W0FJN59NZxK6Mc4U0iw381FJQp2Q7e9lmkQNYzs+AQR86tmWcBWoAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 44",
        "title": "ACE Toolkit integration with ES Configuration Step 44",
        "src": "/tech-academy-apac/static/c42668936b1bdef07df5b9f3155508df/3cbba/2021-09-19_12-48-15.png",
        "srcSet": ["/tech-academy-apac/static/c42668936b1bdef07df5b9f3155508df/7fc1e/2021-09-19_12-48-15.png 288w", "/tech-academy-apac/static/c42668936b1bdef07df5b9f3155508df/a5df1/2021-09-19_12-48-15.png 576w", "/tech-academy-apac/static/c42668936b1bdef07df5b9f3155508df/3cbba/2021-09-19_12-48-15.png 1152w", "/tech-academy-apac/static/c42668936b1bdef07df5b9f3155508df/0b124/2021-09-19_12-48-15.png 1728w", "/tech-academy-apac/static/c42668936b1bdef07df5b9f3155508df/277bd/2021-09-19_12-48-15.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 17
    }}>
      <li parentName="ol">{`To fully confirm the message landed on the corresponding topic, you can navigate to the Event Streams instance and check the message is there. Once you are in the Event Streams Home page click on the `}<strong parentName="li"><em parentName="strong">{`Topics`}</em></strong>{` incon in the navigation section and then click on the topic you used in your flow. In my case `}<strong parentName="li"><em parentName="strong">{`kafka-cp4i-demo-topic`}</em></strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABOElEQVQoz52S3U7CMBTH96Te6KUPYbzygrFda9QEYoxhG2Px4wl8BK+4gsBGZOta1iH7/NsWUUggGTb5pe05p/+e0x7t5PQMN90OunYP10+P6Fg9eP0+bNtWOI6zs5Z4noeBwHHWdsuylN11XWjnF5cYMQKOCvNiheGKo8ThUZYVXp4HeOi9wnwD3oe7fk032lhmGcazAB/BBKPwEyEhIFEExhgiMcdxDEopwjAEEevA9zGZ+hgHFLM5BRM++oN21dYRrJZCbIqvPFe31HW9l41PjqqqxKZEkWdIkgScc4VmmqYKSEQ20iCdx7I5pwQNw1CCsqz/iB0UlPVv0j6WbdHfkuOY7r25idg2mt5qKUH5U6kIUKS88XtydSb9+5Tbu3tkeYF5GImWoGuIbAHWOEMSEyzYQrXYN5mW5JupYIfyAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 45",
        "title": "ACE Toolkit integration with ES Configuration Step 45",
        "src": "/tech-academy-apac/static/b4af7ac20a9d43c8cf7f8fd78b1117af/3cbba/2021-09-19_12-53-16.png",
        "srcSet": ["/tech-academy-apac/static/b4af7ac20a9d43c8cf7f8fd78b1117af/7fc1e/2021-09-19_12-53-16.png 288w", "/tech-academy-apac/static/b4af7ac20a9d43c8cf7f8fd78b1117af/a5df1/2021-09-19_12-53-16.png 576w", "/tech-academy-apac/static/b4af7ac20a9d43c8cf7f8fd78b1117af/3cbba/2021-09-19_12-53-16.png 1152w", "/tech-academy-apac/static/b4af7ac20a9d43c8cf7f8fd78b1117af/0b124/2021-09-19_12-53-16.png 1728w", "/tech-academy-apac/static/b4af7ac20a9d43c8cf7f8fd78b1117af/277bd/2021-09-19_12-53-16.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 18
    }}>
      <li parentName="ol">{`In the topic page navigate to the `}<strong parentName="li"><em parentName="strong">{`Messages`}</em></strong>{` tab, then select the most recent message and confirm the payload includes the same data we sent during the test.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.69444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABiklEQVQoz5WQTW/TQBCG/YPpH+iFCxwAiSStWorgBgcotZPS/oLeekEICQICopQ6ieON489N7DjkYdbgyBJUqCM9mpnV7juzr3VnZ4du1+Hx0RP2nj3l1Dnm7PREsDl/a9Pr2tj235wIx29MdqrecRx6vR7W4dFzTPSDKVNd4qcQaFAZjGPYcLuwHjx8RJppPns/uOwr7r8ec++Vy92XV+y+cLn4oFjqmOUyZ71eUxSF1EvKspRekFw2sA7298lF+avv4YUB7yYDhsGYb8rl+2yEl4Qs9IJitao2MI/yPGez2WwxUdfWXrtNyk+GasqXmc9gplgt8krE5DIvKP+I3RRNcavValWHaRwznM9I0pRMiJKEa+k/+RPeX1/Rn7jCSKwRJJv649jFS5PforWHtWAYhuKVJhWxhXg6mCv6ymMUzvHjCPUP/Cgk1hkr+YHx1mC15csmoiiqxGqyLKsG5IIZcBNa7iWNd9sNm4JZ48J/EUEtQ80CBqvT6WwF68PbYETnYksSJwRBwC8UEeO7uGPSjQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ACE Toolkit integration with ES Configuration Step 46",
        "title": "ACE Toolkit integration with ES Configuration Step 46",
        "src": "/tech-academy-apac/static/e23489c4a30414ea0ac0cf158dbe2dc6/3cbba/2021-09-19_12-55-55.png",
        "srcSet": ["/tech-academy-apac/static/e23489c4a30414ea0ac0cf158dbe2dc6/7fc1e/2021-09-19_12-55-55.png 288w", "/tech-academy-apac/static/e23489c4a30414ea0ac0cf158dbe2dc6/a5df1/2021-09-19_12-55-55.png 576w", "/tech-academy-apac/static/e23489c4a30414ea0ac0cf158dbe2dc6/3cbba/2021-09-19_12-55-55.png 1152w", "/tech-academy-apac/static/e23489c4a30414ea0ac0cf158dbe2dc6/0b124/2021-09-19_12-55-55.png 1728w", "/tech-academy-apac/static/e23489c4a30414ea0ac0cf158dbe2dc6/277bd/2021-09-19_12-55-55.png 1919w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`Congratulations! You have completed this lab.`}</p>
    <hr></hr>
    <h2>{`Summary`}</h2>
    <p>{`You have successfully completed this lab. In this lab you learned:`}</p>
    <ul>
      <li parentName="ul">{`Create and Configure an EventStreams Topic`}</li>
      <li parentName="ul">{`Configure App Connect Enterprise message flow using App Connect Enterprise toolkit`}</li>
      <li parentName="ul">{`Configure App Connect Enterprise service`}</li>
      <li parentName="ul">{`Deploy App Connect BAR file on App Connect Enterprise Server`}</li>
      <li parentName="ul">{`Test App Connect Enterprise API sending a message to EventStreams`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      